// Generated by scripts/generate-blog-index.mjs. Do not edit manually.
export const blogPosts = [
  {
    "id": 161,
    "slug": "microsoft-365-local-costs-licensing-partner-readiness",
    "title": "Microsoft 365 Local Costs, Licensing and Partner Readiness",
    "excerpt": "There is no public price for Microsoft 365 Local. Here is the bill of materials to quote, the total-cost picture to model, and the licensing questions to ask.",
    "date": "Feb 17, 2027",
    "publishDate": "2027-02-17",
    "readTime": "7 min read",
    "category": "Compliance & Governance",
    "pillar": "Process",
    "semanticCluster": "microsoft-365-local-sovereignty",
    "tags": [
      "Microsoft 365 Local",
      "Licensing",
      "Total Cost of Ownership",
      "Partner Readiness",
      "Azure Local",
      "Procurement"
    ],
    "status": "draft",
    "source": "./2027-Q1/161-microsoft-365-local-costs-licensing-partner-readiness.mdx"
  },
  {
    "id": 160,
    "slug": "patching-backup-recovery-without-cloud-connectivity",
    "title": "Patching, Backup and Recovery Without Cloud Connectivity",
    "excerpt": "Disconnected does not mean maintenance-free. The three-layer update model, why the native backup covers only the control plane, and how recovery really works.",
    "date": "Feb 10, 2027",
    "publishDate": "2027-02-10",
    "readTime": "8 min read",
    "category": "Azure Security",
    "pillar": "Technology",
    "semanticCluster": "microsoft-365-local-sovereignty",
    "tags": [
      "Microsoft 365 Local",
      "Disconnected Operations",
      "Patching",
      "Backup",
      "Disaster Recovery",
      "Azure Local"
    ],
    "status": "draft",
    "source": "./2027-Q1/160-patching-backup-recovery-without-cloud-connectivity.mdx"
  },
  {
    "id": 159,
    "slug": "security-governance-controls-microsoft-365-local",
    "title": "Security and Governance: Which Controls Must Be Re-established Locally?",
    "excerpt": "Moving Microsoft 365 workloads on-premises moves their security on-premises too. A control register of what you keep, what you rebuild, and what you lose.",
    "date": "Feb 3, 2027",
    "publishDate": "2027-02-03",
    "readTime": "7 min read",
    "category": "Compliance & Governance",
    "pillar": "Process",
    "semanticCluster": "microsoft-365-local-sovereignty",
    "tags": [
      "Microsoft 365 Local",
      "Security Controls",
      "Governance",
      "Data Sovereignty",
      "Azure Local",
      "Control Register"
    ],
    "status": "draft",
    "source": "./2027-Q1/159-security-governance-controls-microsoft-365-local.mdx"
  },
  {
    "id": 158,
    "slug": "identity-privileged-access-microsoft-365-local",
    "title": "Identity and Privileged Access for Microsoft 365 Local",
    "excerpt": "In disconnected Microsoft 365 Local, identity is your own directory via OIDC and LDAP, not Entra ID. Here is the responsibility model and where it fails.",
    "date": "Jan 27, 2027",
    "publishDate": "2027-01-27",
    "readTime": "7 min read",
    "category": "Azure Security",
    "pillar": "Technology",
    "semanticCluster": "microsoft-365-local-sovereignty",
    "tags": [
      "Microsoft 365 Local",
      "Identity",
      "Privileged Access",
      "Disconnected Operations",
      "AD FS",
      "Azure RBAC"
    ],
    "status": "draft",
    "source": "./2027-Q1/158-identity-privileged-access-microsoft-365-local.mdx"
  },
  {
    "id": 157,
    "slug": "connected-disconnected-operational-boundary",
    "title": "Connected or Disconnected: Designing the Microsoft 365 Local Operational Boundary",
    "excerpt": "In disconnected mode the control plane moves on-premises. Here is the dependency map you must design: control plane, identity, DNS, certificates and networking.",
    "date": "Jan 20, 2027",
    "publishDate": "2027-01-20",
    "readTime": "7 min read",
    "category": "Azure Security",
    "pillar": "Technology",
    "semanticCluster": "microsoft-365-local-sovereignty",
    "tags": [
      "Microsoft 365 Local",
      "Disconnected Operations",
      "Azure Local",
      "Control Plane",
      "Sovereign Private Cloud",
      "Architecture"
    ],
    "status": "draft",
    "source": "./2027-Q1/157-connected-disconnected-operational-boundary.mdx"
  },
  {
    "id": 156,
    "slug": "microsoft-365-local-vs-cloud-when-local-makes-sense",
    "title": "Microsoft 365 Local vs Microsoft 365 Cloud: When Does Local Make Sense?",
    "excerpt": "A decision framework for choosing Microsoft 365 Local over the cloud: sovereignty, connectivity, collaboration needs and the operating capacity you must bring.",
    "date": "Jan 13, 2027",
    "publishDate": "2027-01-13",
    "readTime": "6 min read",
    "category": "Microsoft 365",
    "pillar": "Process",
    "semanticCluster": "microsoft-365-local-sovereignty",
    "tags": [
      "Microsoft 365 Local",
      "Data Sovereignty",
      "Decision Framework",
      "Azure Local",
      "Disconnected Operations",
      "Microsoft 365"
    ],
    "status": "draft",
    "source": "./2027-Q1/156-microsoft-365-local-vs-cloud-when-local-makes-sense.mdx"
  },
  {
    "id": 155,
    "slug": "what-is-microsoft-365-local-workloads",
    "title": "What Is Microsoft 365 Local, and Which Workloads Does It Include?",
    "excerpt": "Microsoft 365 Local runs Exchange, SharePoint and Skype for Business Server on your own Azure Local. Here is what it includes, and what it does not.",
    "date": "Jan 6, 2027",
    "publishDate": "2027-01-06",
    "readTime": "7 min read",
    "category": "Microsoft 365",
    "pillar": "Technology",
    "semanticCluster": "microsoft-365-local-sovereignty",
    "tags": [
      "Microsoft 365 Local",
      "Sovereign Private Cloud",
      "Azure Local",
      "Data Sovereignty",
      "Exchange Server",
      "SharePoint Server"
    ],
    "status": "draft",
    "source": "./2027-Q1/155-what-is-microsoft-365-local-workloads.mdx"
  },
  {
    "id": 154,
    "slug": "negative-testing-copilot-cannot-reach",
    "title": "Negative Testing: Proving Copilot Cannot Reach What It Should Not",
    "excerpt": "Testing that Copilot answers is the easy half. Here is how to test that it cannot reach what it should not, and why most of those tests pass for the wrong reason.",
    "date": "Feb 3, 2027",
    "publishDate": "2027-02-03",
    "readTime": "12 min read",
    "category": "Security Assessment",
    "pillar": "Process",
    "semanticCluster": "Copilot Readiness in SharePoint",
    "tags": [
      "Microsoft 365 Copilot",
      "Security Testing",
      "Data Loss Prevention",
      "Purview",
      "Pilot Design",
      "SharePoint Governance"
    ],
    "status": "draft",
    "source": "./2027-Q1/154-negative-testing-copilot-cannot-reach.mdx"
  },
  {
    "id": 153,
    "slug": "copilot-readiness-report-dspm-inventory-cannot-tell-you",
    "title": "What the Copilot Readiness Report Cannot Tell You",
    "excerpt": "The readiness report says who can use Copilot, not what they could reach. Each instrument answers a different question, and the gap is where oversharing hides.",
    "date": "Jan 27, 2027",
    "publishDate": "2027-01-27",
    "readTime": "11 min read",
    "category": "SharePoint Governance",
    "pillar": "Process",
    "semanticCluster": "Copilot Readiness in SharePoint",
    "tags": [
      "Microsoft 365 Copilot",
      "SharePoint Governance",
      "Data Access Governance",
      "Restricted Content Discovery",
      "Oversharing",
      "Copilot Readiness"
    ],
    "status": "draft",
    "source": "./2027-Q1/153-copilot-readiness-report-dspm-inventory-cannot-tell-you.mdx"
  },
  {
    "id": 151,
    "slug": "audit-trail-after-copilot-agent-acts",
    "title": "The Audit Trail After the Agent Acts",
    "excerpt": "Authoring events are well covered. Reconstructing what an agent did and why needs two solutions, and the text retrieval is best-effort.",
    "date": "Jan 20, 2027",
    "publishDate": "2027-01-20",
    "readTime": "8 min read",
    "category": "Compliance & Governance",
    "pillar": "Process",
    "semanticCluster": "Copilot Agent Governance",
    "tags": [
      "Purview",
      "Audit",
      "DSPM for AI",
      "Copilot Studio",
      "Investigation",
      "Agentic AI"
    ],
    "status": "draft",
    "source": "./2027-Q1/151-audit-trail-after-copilot-agent-acts.mdx"
  },
  {
    "id": 150,
    "slug": "prompt-injection-action-capable-copilot-agent",
    "title": "Prompt Injection Meets an Action-Capable Agent",
    "excerpt": "Defender audits or blocks four named scenarios. Prompt injection is not one of them, and the agent type most likely to be in your pilot has the least coverage.",
    "date": "Jan 13, 2027",
    "publishDate": "2027-01-13",
    "readTime": "8 min read",
    "category": "Technology",
    "pillar": "Technology",
    "semanticCluster": "Copilot Agent Governance",
    "tags": [
      "Prompt injection",
      "Defender",
      "Copilot Studio",
      "Runtime protection",
      "Agentic AI",
      "Preview"
    ],
    "status": "draft",
    "source": "./2027-Q1/150-prompt-injection-action-capable-copilot-agent.mdx"
  },
  {
    "id": 149,
    "slug": "copilot-agent-tools-connectors-triggers-writes",
    "title": "Tools Turn Answers Into Actions: Connectors, Triggers and Writes",
    "excerpt": "Reading is a disclosure problem. Acting is a different one. What data policies can actually block, and why event triggers remove the human from the loop entirely.",
    "date": "Jan 6, 2027",
    "publishDate": "2027-01-06",
    "readTime": "7 min read",
    "category": "Compliance & Governance",
    "pillar": "Process",
    "semanticCluster": "Copilot Agent Governance",
    "tags": [
      "Copilot Studio",
      "Connectors",
      "Data policies",
      "Event triggers",
      "MCP",
      "Agentic AI"
    ],
    "status": "draft",
    "source": "./2026-Q4/149-copilot-agent-tools-connectors-triggers-writes.mdx"
  },
  {
    "id": 148,
    "slug": "copilot-agent-knowledge-sharepoint-access-path",
    "title": "Knowledge Is an Access Path: What SharePoint Can Reveal",
    "excerpt": "Application Restrictions is an authorisation boundary, not a discovery control. Here is what it governs, the first-party gap, and why blocking documents does not block SharePoint.",
    "date": "Dec 23, 2026",
    "publishDate": "2026-12-23",
    "readTime": "8 min read",
    "category": "SharePoint Governance",
    "pillar": "Technology",
    "semanticCluster": "Copilot Agent Governance",
    "tags": [
      "SharePoint",
      "Application Restrictions",
      "Copilot Studio",
      "Knowledge sources",
      "Content Boundary",
      "Agentic AI"
    ],
    "status": "draft",
    "source": "./2026-Q4/148-copilot-agent-knowledge-sharepoint-access-path.mdx"
  },
  {
    "id": 147,
    "slug": "copilot-agent-credentials-user-maker-agent-identity",
    "title": "Whose Credentials: User, Maker, Agent Identity or App?",
    "excerpt": "An agent does not have one set of credentials. It has a choice made per operation, and the agent-level setting does not govern what its tools do.",
    "date": "Dec 16, 2026",
    "publishDate": "2026-12-16",
    "readTime": "8 min read",
    "category": "Microsoft 365",
    "pillar": "Technology",
    "semanticCluster": "Copilot Agent Governance",
    "tags": [
      "Copilot Studio",
      "Authentication",
      "Entra Agent ID",
      "Delegated permissions",
      "Data policies",
      "Agentic AI"
    ],
    "status": "draft",
    "source": "./2026-Q4/147-copilot-agent-credentials-user-maker-agent-identity.mdx"
  },
  {
    "id": 146,
    "slug": "pilot-design-test-shared-tenant-content-boundary",
    "title": "A Pilot Design to Test a Shared-Tenant Content Boundary",
    "excerpt": "A pilot design, not a result. Stage gates and fourteen tests to run before trusting a SharePoint and OneDrive content boundary between two organisations in one Microsoft 365 tenant.",
    "date": "Jan 5, 2027",
    "publishDate": "2027-01-05",
    "readTime": "11 min read",
    "category": "Compliance & Governance",
    "pillar": "Process",
    "semanticCluster": "Shared Tenant Content Boundary",
    "tags": [
      "Pilot Design",
      "SharePoint Restricted Access Control",
      "Entitlement Management",
      "Shared Tenant",
      "Test Plan",
      "Microsoft 365"
    ],
    "status": "draft",
    "source": "./2027-Q1/146-pilot-design-test-shared-tenant-content-boundary.mdx"
  },
  {
    "id": 145,
    "slug": "onedrive-channel-sites-applications-content-boundary-edge-cases",
    "title": "OneDrive, Channels and Apps: Where a Content Boundary Leaks",
    "excerpt": "A site-and-team boundary between two organisations in one Microsoft 365 tenant still leaks through OneDrive, private and shared channels, applications and privileged admins. What Microsoft documents, and what needs its own control.",
    "date": "Dec 29, 2026",
    "publishDate": "2026-12-29",
    "readTime": "8 min read",
    "category": "SharePoint Governance",
    "pillar": "Technology",
    "semanticCluster": "Shared Tenant Content Boundary",
    "tags": [
      "SharePoint",
      "OneDrive",
      "Microsoft Teams",
      "Restricted Access Control",
      "Application Restrictions",
      "Shared Tenant"
    ],
    "status": "draft",
    "source": "./2026-Q4/145-onedrive-channel-sites-applications-content-boundary-edge-cases.mdx"
  },
  {
    "id": 144,
    "slug": "entra-entitlement-management-teams-sharepoint-access-two-organisations",
    "title": "Entitlement Management for Teams Access Across Two Organisations",
    "excerpt": "How access to a joint Teams and SharePoint workspace can be requested, approved by both organisations, expired and reviewed with Microsoft Entra entitlement management, and the gap you still need to close.",
    "date": "Dec 22, 2026",
    "publishDate": "2026-12-22",
    "readTime": "8 min read",
    "category": "Compliance & Governance",
    "pillar": "Process",
    "semanticCluster": "Shared Tenant Content Boundary",
    "tags": [
      "Entra ID Governance",
      "Entitlement Management",
      "Microsoft Teams",
      "SharePoint",
      "Access Reviews",
      "Shared Tenant"
    ],
    "status": "draft",
    "source": "./2026-Q4/144-entra-entitlement-management-teams-sharepoint-access-two-organisations.mdx"
  },
  {
    "id": 143,
    "slug": "sharepoint-restricted-access-control-site-permissions-not-enough",
    "title": "SharePoint Restricted Access Control: Beyond Site Permissions",
    "excerpt": "Ordinary SharePoint permissions say who may open a site. Restricted access control adds a second check. Here is what it adds, what it does not, and where it surprises people.",
    "date": "Dec 15, 2026",
    "publishDate": "2026-12-15",
    "readTime": "8 min read",
    "category": "SharePoint Governance",
    "pillar": "Technology",
    "semanticCluster": "Shared Tenant Content Boundary",
    "tags": [
      "SharePoint",
      "Restricted Access Control",
      "SharePoint Advanced Management",
      "Permissions",
      "Content Boundary",
      "Copilot"
    ],
    "status": "draft",
    "source": "./2026-Q4/143-sharepoint-restricted-access-control-site-permissions-not-enough.mdx"
  },
  {
    "id": 142,
    "slug": "two-organisations-one-microsoft-365-tenant-content-boundary",
    "title": "Two Organisations, One Microsoft 365 Tenant: Where Content Stops",
    "excerpt": "Can two organisations share one Microsoft 365 tenant and still keep their files apart? A decision guide for executives and IT leaders, based on Microsoft documentation.",
    "date": "Dec 8, 2026",
    "publishDate": "2026-12-08",
    "readTime": "8 min read",
    "category": "Microsoft 365",
    "pillar": "Technology",
    "semanticCluster": "Shared Tenant Content Boundary",
    "tags": [
      "Microsoft 365",
      "Tenant Architecture",
      "SharePoint",
      "Governance",
      "Managed Service Provider",
      "Content Boundary"
    ],
    "status": "draft",
    "source": "./2026-Q4/142-two-organisations-one-microsoft-365-tenant-content-boundary.mdx"
  },
  {
    "id": 140,
    "slug": "five-permission-checks-sharepoint-site-owners-copilot",
    "title": "Five Permission Checks Every SharePoint Site Owner Should Run",
    "excerpt": "Copilot does not break your permissions. It reveals them. Five checks a site owner can run in under an hour, no admin rights needed, before Copilot reaches your site.",
    "date": "Nov 3, 2026",
    "publishDate": "2026-11-03",
    "readTime": "12 min read",
    "category": "SharePoint Governance",
    "pillar": "Process",
    "semanticCluster": "SharePoint Governance for Copilot",
    "tags": [
      "SharePoint",
      "Site Owners",
      "Microsoft Copilot",
      "Oversharing",
      "Permissions",
      "Privacy Act"
    ],
    "status": "published",
    "source": "./2026-Q4/140-five-permission-checks-sharepoint-site-owners-copilot.mdx"
  },
  {
    "id": 138,
    "slug": "microsoft-copilot-agentic-ai-governance-australia",
    "title": "Who Owns and Sponsors a Copilot Agent in Your Tenant?",
    "excerpt": "An agent that acts needs someone accountable for it. Microsoft separates technical ownership from business sponsorship, and the split has consequences most teams discover too late.",
    "date": "Dec 2, 2026",
    "publishDate": "2026-12-02",
    "readTime": "9 min read",
    "category": "Compliance & Governance",
    "pillar": "Process",
    "semanticCluster": "Copilot Agent Governance",
    "tags": [
      "Copilot Studio",
      "Agent 365",
      "Entra Agent ID",
      "Agentic AI",
      "Accountability",
      "ASD Essentials"
    ],
    "status": "draft",
    "source": "./2026-Q4/138-microsoft-copilot-agentic-ai-governance-australia.mdx"
  },
  {
    "id": 137,
    "slug": "microsoft-365-features-agents-enabled-by-default-governance",
    "title": "Find the Agents First: Published, Shared, Unmanaged and Ownerless",
    "excerpt": "You cannot govern agents you cannot see. The Microsoft 365 agent registry shows four publisher types, duplicate rows by design, and one documented hole where drafts hide.",
    "date": "Dec 9, 2026",
    "publishDate": "2026-12-09",
    "readTime": "11 min read",
    "category": "Microsoft 365",
    "pillar": "Process",
    "semanticCluster": "Copilot Agent Governance",
    "tags": [
      "Microsoft 365",
      "Copilot agents",
      "Agent 365",
      "Agent registry",
      "Shadow IT",
      "Inventory"
    ],
    "status": "draft",
    "source": "./2026-Q4/137-microsoft-365-features-agents-enabled-by-default-governance.mdx"
  },
  {
    "id": 136,
    "slug": "smb-essential-eight-playbook-maturity-level-2-australia",
    "title": "The SMB Essential Eight Playbook: From Zero to Maturity Level 2 Without a Security Team",
    "excerpt": "A plain-English Essential Eight playbook for Australian small businesses without a security team. What the eight controls are, why Maturity Level 2 is the realistic target, and one concrete action for each.",
    "date": "Jul 4, 2026",
    "publishDate": "2026-07-04",
    "readTime": "7 min read",
    "category": "Essential Eight",
    "pillar": "Process",
    "semanticCluster": "SMB Cyber Security Assessment",
    "tags": [
      "Essential Eight",
      "ACSC Essential Eight",
      "Small Business",
      "Australian Cybersecurity",
      "Cyber Insurance",
      "Microsoft 365"
    ],
    "status": "published",
    "source": "./2026-Q3/136-smb-essential-eight-playbook-maturity-level-2-australia.mdx"
  },
  {
    "id": 135,
    "slug": "mfa-attestation-australian-smbs-insurance-compliance",
    "title": "MFA Attestation for Australian SMBs: What Cyber Insurers Actually Require",
    "excerpt": "Australian small businesses face growing cyber insurance MFA attestation requirements. This guide explains exactly what MFA controls insurers require, how to prove them, and how to fix common gaps before your next policy renewal.",
    "date": "Jul 1, 2026",
    "publishDate": "2026-07-01",
    "readTime": "9 min read",
    "category": "Security Culture",
    "pillar": "Security Culture",
    "semanticCluster": "SMB Cyber Security Assessment",
    "tags": [
      "MFA",
      "Cyber Insurance",
      "Australian Cybersecurity",
      "Small Business",
      "ACSC Essential Eight",
      "Microsoft 365"
    ],
    "status": "published",
    "source": "./2026-Q3/135-mfa-attestation-australian-smbs-insurance-compliance.mdx"
  },
  {
    "id": 134,
    "slug": "copilot-application-control-patch-management-essential-eight-australia",
    "title": "Copilot, Application Control and Patch Management: Satisfying Essential Eight ML2 in Australia",
    "excerpt": "Deep-dive guidance for Australian organisations applying Essential Eight-aligned application governance and patch response practices to Microsoft 365 Copilot deployments.",
    "date": "Jun 28, 2026",
    "publishDate": "2026-06-28",
    "readTime": "9 min read",
    "category": "ACSC Essential Eight",
    "pillar": "Technology",
    "semanticCluster": "Copilot Essential Eight Alignment",
    "tags": [
      "Application Control",
      "Patch Management",
      "Essential Eight ML2",
      "Microsoft 365 Copilot",
      "ACSC Compliance",
      "Copilot Security"
    ],
    "status": "published",
    "source": "./2026-Q3/134-copilot-application-control-patch-management-essential-eight-australia.mdx"
  },
  {
    "id": 133,
    "slug": "how-to-align-microsoft-365-copilot-essential-eight-controls-australia",
    "title": "How to Align Microsoft 365 Copilot with Essential Eight Controls in Australia",
    "excerpt": "A practical step-by-step guide for Australian organisations to align Microsoft 365 Copilot deployments with the ACSC Essential Eight controls and achieve demonstrable compliance.",
    "date": "Jun 25, 2026",
    "publishDate": "2026-06-25",
    "readTime": "11 min read",
    "category": "ACSC Essential Eight",
    "pillar": "Technology",
    "semanticCluster": "Copilot Essential Eight Alignment",
    "tags": [
      "Essential Eight",
      "Microsoft 365 Copilot",
      "ACSC Compliance",
      "Copilot Security",
      "Australian Cyber Security",
      "Zero Trust"
    ],
    "status": "published",
    "source": "./2026-Q3/133-how-to-align-microsoft-365-copilot-essential-eight-controls-australia.mdx"
  },
  {
    "id": 132,
    "slug": "copilot-data-governance-policy-template-australian-organisations",
    "title": "Copilot Data Governance Policy Template for Australian Organisations",
    "excerpt": "A practical Copilot data governance policy template for Australian organisations, covering acceptable use, data classification, access controls, audit requirements, and Privacy Act compliance.",
    "date": "Jun 22, 2026",
    "publishDate": "2026-06-22",
    "readTime": "10 min read",
    "category": "Compliance & Governance",
    "pillar": "Technology",
    "semanticCluster": "Copilot Governance Maturity",
    "tags": [
      "Copilot Governance",
      "Data Governance Policy",
      "Microsoft 365 Copilot",
      "Australian Privacy Act",
      "Acceptable Use Policy",
      "Compliance & Governance"
    ],
    "status": "published",
    "source": "./2026-Q3/132-copilot-data-governance-policy-template-australian-organisations.mdx"
  },
  {
    "id": 131,
    "slug": "how-to-configure-microsoft-purview-sensitivity-labels-copilot-australia",
    "title": "How to Configure Microsoft Purview Sensitivity Labels for Copilot in Australia",
    "excerpt": "Step-by-step guide to configuring Microsoft Purview sensitivity labels for Microsoft 365 Copilot in Australian organisations, covering label taxonomy, auto-labelling policies, and Copilot data boundary controls.",
    "date": "Jun 19, 2026",
    "publishDate": "2026-06-19",
    "readTime": "9 min read",
    "category": "Compliance & Governance",
    "pillar": "Technology",
    "semanticCluster": "Copilot Governance Maturity",
    "tags": [
      "Microsoft Purview",
      "Sensitivity Labels",
      "Microsoft 365 Copilot",
      "Data Governance",
      "Australian Compliance",
      "Information Protection"
    ],
    "status": "published",
    "source": "./2026-Q3/131-how-to-configure-microsoft-purview-sensitivity-labels-copilot-australia.mdx"
  },
  {
    "id": 130,
    "slug": "copilot-deployment-readiness-checklist-australia-2026",
    "title": "Copilot Deployment Readiness Checklist for Australian IT Teams 2026",
    "excerpt": "A comprehensive, actionable checklist covering identity, data governance, security controls, and compliance requirements before deploying Microsoft 365 Copilot in Australia.",
    "date": "Jun 16, 2026",
    "publishDate": "2026-06-16",
    "readTime": "10 min read",
    "category": "Technology",
    "pillar": "Technology",
    "semanticCluster": "Copilot Deployment Readiness Assessment",
    "tags": [
      "Microsoft 365 Copilot",
      "Copilot Readiness",
      "Microsoft 365",
      "AI Governance",
      "Australian Cybersecurity",
      "ACSC Essential Eight"
    ],
    "status": "published",
    "source": "./2026-Q3/130-copilot-deployment-readiness-checklist-australia-2026.mdx"
  },
  {
    "id": 129,
    "slug": "how-to-run-microsoft-365-copilot-pilot-program-australia",
    "title": "How to Run a Microsoft 365 Copilot Pilot Program in Your Australian Organisation",
    "excerpt": "A practical step-by-step guide for Australian IT teams to plan, execute, and evaluate a Microsoft 365 Copilot pilot that is secure, compliant, and genuinely useful.",
    "date": "Jun 13, 2026",
    "publishDate": "2026-06-13",
    "readTime": "8 min read",
    "category": "Technology",
    "pillar": "Technology",
    "semanticCluster": "Copilot Deployment Readiness Assessment",
    "tags": [
      "Microsoft 365 Copilot",
      "Copilot Pilot Program",
      "Microsoft 365",
      "AI Deployment",
      "Australian Cybersecurity",
      "Change Management"
    ],
    "status": "published",
    "source": "./2026-Q3/129-how-to-run-microsoft-365-copilot-pilot-program-australia.mdx"
  },
  {
    "id": 128,
    "slug": "microsoft-teams-governance-policy-template-australian-organisations",
    "title": "Microsoft Teams Governance Policy Template for Australian Organisations",
    "excerpt": "A practical Microsoft Teams governance policy template tailored for Australian organisations, covering team creation, naming, lifecycle, and compliance requirements.",
    "date": "Jun 10, 2026",
    "publishDate": "2026-06-10",
    "readTime": "11 min read",
    "category": "Compliance & Governance",
    "pillar": "Technology",
    "semanticCluster": "SharePoint and Teams Governance Assessment",
    "tags": [
      "Microsoft Teams Governance",
      "Teams Policy",
      "SharePoint Governance",
      "Compliance & Governance",
      "Microsoft 365",
      "Australian Compliance"
    ],
    "status": "published",
    "source": "./2026-Q3/128-microsoft-teams-governance-policy-template-australian-organisations.mdx"
  },
  {
    "id": 127,
    "slug": "how-to-configure-restricted-sharepoint-search-microsoft-365-copilot",
    "title": "How to Use Restricted Content Discovery to Govern Microsoft 365 Copilot",
    "excerpt": "A step-by-step guide to Restricted Content Discovery, Restricted Access Control and SharePoint Advanced Management reports, the controls Microsoft now points to for Copilot oversharing.",
    "date": "Jun 7, 2026",
    "publishDate": "2026-06-07",
    "readTime": "9 min read",
    "category": "Compliance & Governance",
    "pillar": "Technology",
    "semanticCluster": "SharePoint and Teams Governance Assessment",
    "tags": [
      "SharePoint Governance",
      "Microsoft 365 Copilot",
      "Restricted Content Discovery",
      "SharePoint Advanced Management",
      "Data Governance",
      "Microsoft 365"
    ],
    "status": "published",
    "source": "./2026-Q3/127-how-to-configure-restricted-sharepoint-search-microsoft-365-copilot.mdx"
  },
  {
    "id": 126,
    "slug": "how-to-set-up-mfa-microsoft-365-small-business-australia",
    "title": "How to Set Up MFA in Microsoft 365 for Australian Small Business",
    "excerpt": "Step-by-step guide to enabling multi-factor authentication in Microsoft 365 for Australian small businesses, covering Security Defaults, per-user MFA, and Conditional Access.",
    "date": "Jun 4, 2026",
    "publishDate": "2026-06-04",
    "readTime": "9 min read",
    "category": "Microsoft 365",
    "pillar": "Technology",
    "semanticCluster": "smb-cyber-security",
    "tags": [
      "MFA Microsoft 365",
      "multi-factor authentication",
      "Microsoft 365 small business",
      "Australian cybersecurity",
      "Essential Eight MFA",
      "Microsoft Entra ID"
    ],
    "status": "published",
    "source": "./2026-Q3/126-how-to-set-up-mfa-microsoft-365-small-business-australia.mdx"
  },
  {
    "id": 125,
    "slug": "cyber-security-checklist-australian-small-business-2026",
    "title": "Cyber Security Checklist for Australian Small Business 2026",
    "excerpt": "A practical cyber security checklist for Australian small businesses in 2026, covering the controls that matter most to protect your data, money, and reputation.",
    "date": "Jun 1, 2026",
    "publishDate": "2026-06-01",
    "readTime": "10 min read",
    "category": "Security Assessment",
    "pillar": "Technology",
    "semanticCluster": "smb-cyber-security",
    "tags": [
      "cyber security checklist",
      "small business Australia",
      "SMB security",
      "Australian cybersecurity 2026",
      "Essential Eight",
      "security assessment"
    ],
    "status": "published",
    "source": "./2026-Q3/125-cyber-security-checklist-australian-small-business-2026.mdx"
  },
  {
    "id": 124,
    "slug": "essential-eight-gap-analysis-checklist-2026-australia",
    "title": "Essential Eight Gap Analysis Checklist 2026: A Practical Walkthrough for Australian Organisations",
    "excerpt": "A practical gap analysis checklist for Australian organisations assessing their Essential Eight compliance in 2026, with control-level questions for all eight strategies.",
    "date": "May 29, 2026",
    "publishDate": "2026-05-29",
    "readTime": "11 min read",
    "category": "ACSC Essential Eight",
    "pillar": "Technology",
    "semanticCluster": "essential-eight-maturity",
    "tags": [
      "Essential Eight",
      "gap analysis",
      "ACSC compliance",
      "Australian cybersecurity",
      "maturity assessment",
      "2026 checklist"
    ],
    "status": "published",
    "source": "./2026-Q3/124-essential-eight-gap-analysis-checklist-2026-australia.mdx"
  },
  {
    "id": 123,
    "slug": "how-to-prepare-essential-eight-ml2-evidence-pack-australia",
    "title": "How to Prepare an Essential Eight ML2 Evidence Pack for Australian Auditors",
    "excerpt": "Step-by-step guide to assembling an Essential Eight Maturity Level 2 evidence pack that satisfies Australian auditors and demonstrates genuine control effectiveness.",
    "date": "May 26, 2026",
    "publishDate": "2026-05-26",
    "readTime": "10 min read",
    "category": "ACSC Essential Eight",
    "pillar": "Technology",
    "semanticCluster": "essential-eight-maturity",
    "tags": [
      "Essential Eight",
      "ML2 evidence",
      "ACSC audit",
      "Australian compliance",
      "maturity level 2",
      "evidence pack"
    ],
    "status": "published",
    "source": "./2026-Q3/123-how-to-prepare-essential-eight-ml2-evidence-pack-australia.mdx"
  },
  {
    "id": 122,
    "slug": "active-directory-health-check-powershell-commands-australia",
    "title": "Active Directory Health Check: PowerShell Commands Every Australian IT Team Should Run",
    "excerpt": "The essential PowerShell commands for an Active Directory health check, mapped to ACSC Essential Eight and ISM controls for Australian IT and security teams.",
    "date": "May 23, 2026",
    "publishDate": "2026-05-23",
    "readTime": "10 min read",
    "category": "Security Assessment",
    "pillar": "Technology",
    "semanticCluster": "active-directory-assessment",
    "tags": [
      "Active Directory",
      "PowerShell",
      "Security Assessment",
      "Health Check",
      "Essential Eight",
      "Australian IT Security"
    ],
    "status": "published",
    "source": "./2026-Q3/122-active-directory-health-check-powershell-commands-australia.mdx"
  },
  {
    "id": 121,
    "slug": "how-to-implement-active-directory-tier-model-essential-eight-ml2-australia",
    "title": "How to Implement the Active Directory Tier Model for Essential Eight ML2",
    "excerpt": "Learn how to implement the Active Directory Tier Model to meet ACSC Essential Eight ML2 requirements, with practical steps for Australian organisations.",
    "date": "May 20, 2026",
    "publishDate": "2026-05-20",
    "readTime": "9 min read",
    "category": "ACSC Essential Eight",
    "pillar": "Technology",
    "semanticCluster": "active-directory-assessment",
    "tags": [
      "Active Directory",
      "Essential Eight",
      "Tier Model",
      "Privileged Access",
      "ML2 Compliance",
      "Identity Security"
    ],
    "status": "published",
    "source": "./2026-Q3/121-how-to-implement-active-directory-tier-model-essential-eight-ml2-australia.mdx"
  },
  {
    "id": 120,
    "slug": "privileged-identity-management-pim-setup-guide-australia",
    "title": "Privileged Identity Management (PIM) Setup Guide for Australian Organisations",
    "excerpt": "Set up Microsoft Entra Privileged Identity Management in five phases — licence check, role discovery, eligibility configuration, approval workflows, and break-glass design for Australian organisations.",
    "date": "May 17, 2026",
    "publishDate": "2026-05-17",
    "readTime": "9 min read",
    "category": "Security Assessment",
    "pillar": "Technology",
    "semanticCluster": "Identity and Access Assessment",
    "tags": [
      "Privileged Identity Management",
      "PIM",
      "Entra ID",
      "Just-In-Time Access",
      "ASD ISM",
      "ACSC Essential Eight"
    ],
    "status": "published",
    "source": "./2026-Q3/120-privileged-identity-management-pim-setup-guide-australia.mdx"
  },
  {
    "id": 119,
    "slug": "how-to-audit-entra-id-guest-accounts-australian-organisations",
    "title": "How to Audit Entra ID Guest Accounts in Australian Organisations",
    "excerpt": "Audit Entra ID guest accounts in five structured steps — covering discovery, access review, expiry policy, cross-tenant settings, and Privacy Act evidence for Australian organisations.",
    "date": "May 14, 2026",
    "publishDate": "2026-05-14",
    "readTime": "8 min read",
    "category": "Security Assessment",
    "pillar": "Technology",
    "semanticCluster": "Identity and Access Assessment",
    "tags": [
      "Entra ID",
      "Guest Accounts",
      "Identity Audit",
      "B2B Collaboration",
      "Privacy Act",
      "ACSC Essential Eight"
    ],
    "status": "published",
    "source": "./2026-Q3/119-how-to-audit-entra-id-guest-accounts-australian-organisations.mdx"
  },
  {
    "id": 118,
    "slug": "microsoft-365-security-defaults-vs-conditional-access-australia",
    "title": "Microsoft 365 Security Defaults vs Conditional Access: Which Should Australian SMBs Choose?",
    "excerpt": "Security Defaults or Conditional Access — the choice defines your Microsoft 365 identity security posture. This guide helps Australian SMBs make the right call for their size and risk profile.",
    "date": "May 11, 2026",
    "publishDate": "2026-05-11",
    "readTime": "10 min read",
    "category": "Microsoft 365",
    "pillar": "Technology",
    "semanticCluster": "Microsoft 365 Health Check",
    "tags": [
      "Microsoft 365 Security",
      "Conditional Access",
      "Security Defaults",
      "Australian SMB",
      "Multi-Factor Authentication",
      "Identity Security"
    ],
    "status": "published",
    "source": "./2026-Q3/118-microsoft-365-security-defaults-vs-conditional-access-australia.mdx"
  },
  {
    "id": 117,
    "slug": "how-to-read-microsoft-secure-score-dashboard-australian-smb",
    "title": "How to Read Your Microsoft Secure Score Dashboard (Australian SMB Guide)",
    "excerpt": "Learn to interpret Microsoft Secure Score step by step. This practical guide helps Australian SMBs turn dashboard numbers into prioritised security actions that reduce real risk.",
    "date": "May 8, 2026",
    "publishDate": "2026-05-08",
    "readTime": "9 min read",
    "category": "Microsoft 365",
    "pillar": "Technology",
    "semanticCluster": "Microsoft 365 Health Check",
    "tags": [
      "Microsoft Secure Score",
      "Microsoft 365 Security",
      "Australian SMB",
      "Security Hardening",
      "ACSC Essential Eight",
      "Cyber Hygiene"
    ],
    "status": "published",
    "source": "./2026-Q3/117-how-to-read-microsoft-secure-score-dashboard-australian-smb.mdx"
  },
  {
    "id": 116,
    "slug": "sharepoint-ia-for-copilot-2026-pillar",
    "title": "SharePoint Information Architecture for Microsoft 365 Copilot: The 2026 Australian and EU Readiness Guide",
    "excerpt": "The only Australian-built SharePoint Information Architecture playbook for Microsoft 365 Copilot under the Privacy Act 1988, OAIC NDB and Essential Eight — ready before the June 2026 opt-out switch.",
    "date": "May 5, 2026",
    "publishDate": "2026-05-05",
    "readTime": "9 min read",
    "category": "SharePoint Governance",
    "pillar": "Technology",
    "semanticCluster": "SharePoint Copilot Governance",
    "tags": [
      "SharePoint",
      "Microsoft 365 Copilot",
      "Information Architecture",
      "Australian Privacy Act",
      "GDPR",
      "EU AI Act",
      "Purview",
      "Essential Eight"
    ],
    "status": "published",
    "source": "./2026-Q2/116-sharepoint-ia-for-copilot-2026-pillar.mdx"
  },
  {
    "id": 115,
    "slug": "active-directory-recovery-runbook-resource",
    "title": "Active Directory Forest Recovery Runbook for Australian Organisations",
    "excerpt": "A printable, step-by-step Active Directory forest recovery runbook aligned to Microsoft's AD Forest Recovery Guide, ACSC hardening guidance, and Essential Eight Maturity Level 2 backup and recovery evidence requirements for Australian organisations.",
    "date": "May 24, 2026",
    "publishDate": "2026-05-24",
    "readTime": "8 min read",
    "category": "Ebook",
    "pillar": "Process",
    "semanticCluster": "Active Directory Resilience",
    "tags": [
      "Active Directory",
      "Forest Recovery",
      "Incident Response",
      "Essential Eight",
      "Backup and Recovery",
      "Runbook"
    ],
    "status": "draft",
    "source": "./2026-Q2/115-active-directory-recovery-runbook-resource.mdx"
  },
  {
    "id": 114,
    "slug": "smb-cyber-insurance-evidence-pack-resource",
    "title": "SMB Cyber Insurance Evidence Pack Template for Australian Small Business",
    "excerpt": "Downloadable evidence-pack template for Australian small businesses applying for or renewing cyber insurance in 2026. Covers the 40 most common underwriting questions, evidence checklists, MFA, patching, backup and training attestation forms, a broker-ready summary, and a renewal trigger calendar.",
    "date": "May 24, 2026",
    "publishDate": "2026-05-24",
    "readTime": "9 min read",
    "category": "Ebook",
    "pillar": "Process",
    "semanticCluster": "SMB Cyber Resilience",
    "tags": [
      "Cyber Insurance",
      "Small Business",
      "Underwriting",
      "Evidence Pack",
      "ACSC Small Business",
      "Australia"
    ],
    "status": "draft",
    "source": "./2026-Q2/114-smb-cyber-insurance-evidence-pack-resource.mdx"
  },
  {
    "id": 113,
    "slug": "app-8-anthropic-subprocessor-disclosure-template-resource",
    "title": "APP 8 Anthropic Subprocessor Disclosure Template for Australian Organisations",
    "excerpt": "A ready-to-edit DOCX and PDF template that helps Australian privacy officers document the Anthropic subprocessor relationship that sits behind Microsoft 365 Copilot Cowork and Copilot Studio agents, in line with Australian Privacy Principle 8.",
    "date": "May 24, 2026",
    "publishDate": "2026-06-07",
    "readTime": "7 min read",
    "category": "Ebook",
    "pillar": "Process",
    "semanticCluster": "Copilot Governance",
    "tags": [
      "Privacy Act",
      "APP 8",
      "Microsoft Copilot",
      "Anthropic",
      "Copilot Cowork",
      "Compliance Template"
    ],
    "status": "draft",
    "source": "./2026-Q2/113-app-8-anthropic-subprocessor-disclosure-template-resource.mdx"
  },
  {
    "id": 112,
    "slug": "essential-eight-maturity-level-2-evidence-pack-resource",
    "title": "Essential Eight Maturity Level 2 Evidence Pack — Free Download for Australian Organisations",
    "excerpt": "Downloadable Essential Eight Maturity Level 2 evidence pack — per-control evidence checklist, IRAP-aligned cross-reference table, citation register and owner sign-off page for Australian organisations preparing for ASD-aligned assessment.",
    "date": "May 24, 2026",
    "publishDate": "2026-05-24",
    "readTime": "8 min read",
    "category": "Ebook",
    "pillar": "Technology",
    "semanticCluster": "Essential Eight Maturity",
    "tags": [
      "Essential Eight",
      "Maturity Level 2",
      "Evidence Pack",
      "IRAP",
      "ACSC",
      "ASD",
      "ISM",
      "Download"
    ],
    "status": "draft",
    "source": "./2026-Q2/112-essential-eight-maturity-level-2-evidence-pack-resource.mdx"
  },
  {
    "id": 111,
    "slug": "hybrid-ad-entra-cutover-risk-register",
    "title": "Hybrid AD to Entra Cutover Risk Register: The Australian Practitioner List",
    "excerpt": "The named risks Australian programmes most often miss during a hybrid Active Directory to Microsoft Entra ID cutover — with likelihood, impact, and the mitigation each risk needs before go-live.",
    "date": "May 2, 2026",
    "publishDate": "2026-05-02",
    "readTime": "11 min read",
    "category": "Process",
    "pillar": "Process",
    "semanticCluster": "Active Directory Resilience",
    "tags": [
      "Risk Register",
      "Entra ID",
      "Hybrid Identity",
      "Active Directory",
      "Cutover",
      "Programme Management"
    ],
    "status": "published",
    "source": "./2026-Q2/111-hybrid-ad-entra-cutover-risk-register.mdx"
  },
  {
    "id": 110,
    "slug": "golden-ticket-detection-active-directory",
    "title": "How to Detect and Respond to Golden Ticket Attacks in Active Directory",
    "excerpt": "A practitioner guide for Australian Active Directory administrators on detecting golden ticket attacks against the krbtgt account — Kerberos event log baselines, Microsoft Defender for Identity rules, and the response playbook including double krbtgt reset.",
    "date": "Apr 29, 2026",
    "publishDate": "2026-04-29",
    "readTime": "11 min read",
    "category": "Technology",
    "pillar": "Technology",
    "semanticCluster": "Active Directory Resilience",
    "tags": [
      "Golden Ticket",
      "Kerberos",
      "Active Directory",
      "Threat Detection",
      "krbtgt",
      "MITRE ATT&CK"
    ],
    "status": "published",
    "source": "./2026-Q2/110-golden-ticket-detection-active-directory.mdx"
  },
  {
    "id": 109,
    "slug": "hybrid-ad-to-entra-cutover-walkthrough",
    "title": "How to Cut Over from Hybrid AD to Microsoft Entra ID (Australian Walk-through)",
    "excerpt": "An end-to-end walk-through for Australian organisations retiring on-premises Active Directory in favour of Microsoft Entra ID — what to keep, the order to retire AD Connect and ADFS, and the resilience controls that survive cutover.",
    "date": "Apr 26, 2026",
    "publishDate": "2026-04-26",
    "readTime": "12 min read",
    "category": "Technology",
    "pillar": "Technology",
    "semanticCluster": "Active Directory Resilience",
    "tags": [
      "Entra ID",
      "Hybrid Identity",
      "AD Connect",
      "Cloud Identity",
      "Active Directory",
      "ADFS"
    ],
    "status": "published",
    "source": "./2026-Q2/109-hybrid-ad-to-entra-cutover-walkthrough.mdx"
  },
  {
    "id": 108,
    "slug": "active-directory-backup-verification-forest-recovery-rehearsal",
    "title": "How to Verify AD Backups and Run a Forest Recovery Rehearsal (Australian Recipe)",
    "excerpt": "A step-by-step recipe for Australian Active Directory administrators on verifying System State backups, building a recovery lab, and running an annual forest recovery rehearsal aligned to Essential Eight Maturity Level 2.",
    "date": "Apr 23, 2026",
    "publishDate": "2026-04-23",
    "readTime": "12 min read",
    "category": "Process",
    "pillar": "Process",
    "semanticCluster": "Active Directory Resilience",
    "tags": [
      "AD Backup",
      "Forest Recovery",
      "Essential Eight",
      "Active Directory",
      "Disaster Recovery",
      "ASD"
    ],
    "status": "published",
    "source": "./2026-Q2/108-active-directory-backup-verification-forest-recovery-rehearsal.mdx"
  },
  {
    "id": 107,
    "slug": "tier-0-isolation-hybrid-active-directory",
    "title": "How to Isolate Tier 0 in a Hybrid Active Directory Environment (Australian Recipe)",
    "excerpt": "A practitioner walk-through for Australian organisations on declaring Tier 0, separating administrative accounts, and standing up privileged access workstations in hybrid AD environments against ASD ISM and Essential Eight.",
    "date": "Apr 20, 2026",
    "publishDate": "2026-04-20",
    "readTime": "11 min read",
    "category": "Technology",
    "pillar": "Technology",
    "semanticCluster": "Active Directory Resilience",
    "tags": [
      "Tier 0",
      "Privileged Access",
      "Active Directory",
      "PAW",
      "Hybrid Identity",
      "Essential Eight"
    ],
    "status": "published",
    "source": "./2026-Q2/107-tier-0-isolation-hybrid-active-directory.mdx"
  },
  {
    "id": 106,
    "slug": "ad-tier-model-essential-eight-ml2-recovery-australia",
    "title": "AD Tier Model and Essential Eight ML2 Recovery (Australia)",
    "excerpt": "How Australian organisations align Microsoft's Active Directory tier model with ASD Essential Eight Maturity Level 2 backup, recovery, and privileged access controls — a practitioner playbook for hybrid identity resilience.",
    "date": "Apr 17, 2026",
    "publishDate": "2026-04-17",
    "readTime": "18 min read",
    "category": "ACSC Essential Eight",
    "pillar": "Technology",
    "semanticCluster": "Active Directory Resilience",
    "tags": [
      "Active Directory",
      "Tier 0",
      "Essential Eight",
      "ASD",
      "Hybrid Identity",
      "Forest Recovery",
      "Australia"
    ],
    "status": "published",
    "source": "./2026-Q2/106-ad-tier-model-essential-eight-ml2-recovery-australia.mdx"
  },
  {
    "id": 105,
    "slug": "essential-eight-evidence-pack-irap-format-checklist-copilot-scope",
    "title": "Essential Eight evidence-pack IRAP-format checklist for the Copilot scope",
    "excerpt": "How-to checklist for assembling an IRAP-format Essential Eight evidence pack for a Microsoft 365 Copilot deployment — one folder per control, the expected artefacts, and the attestation rhythm Australian assessors expect.",
    "date": "Apr 14, 2026",
    "publishDate": "2026-04-14",
    "readTime": "13 min read",
    "category": "ACSC Essential Eight",
    "pillar": "Process",
    "semanticCluster": "Copilot Essential Eight Alignment",
    "tags": [
      "IRAP",
      "Essential Eight",
      "Evidence Pack",
      "Maturity Level 2",
      "Microsoft 365 Copilot",
      "ASD Blueprint",
      "Australian Cyber Security"
    ],
    "status": "published",
    "source": "./2026-Q2/105-essential-eight-evidence-pack-irap-format-checklist-copilot-scope.mdx"
  },
  {
    "id": 104,
    "slug": "application-control-copilot-studio-agents",
    "title": "Application control for Copilot Studio agents — the Essential Eight how-to for 2026",
    "excerpt": "Step-by-step how-to for applying ASD Essential Eight application control to Copilot Studio agents in Australian tenants — publishing gates, approved publishers, connector allow-lists, and the agent register.",
    "date": "Apr 11, 2026",
    "publishDate": "2026-04-11",
    "readTime": "11 min read",
    "category": "ACSC Essential Eight",
    "pillar": "Technology",
    "semanticCluster": "Copilot Essential Eight Alignment",
    "tags": [
      "Copilot Studio",
      "Application Control",
      "Essential Eight",
      "Maturity Level 2",
      "Agent Governance",
      "Australian Cyber Security"
    ],
    "status": "published",
    "source": "./2026-Q2/104-application-control-copilot-studio-agents.mdx"
  },
  {
    "id": 103,
    "slug": "mapping-microsoft-365-copilot-asd-essential-eight-maturity-level-2-2026",
    "title": "Mapping Microsoft 365 Copilot to Essential Eight ML2 (2026)",
    "excerpt": "Practitioner-led 2026 control mapping showing exactly how Microsoft 365 Copilot configuration aligns to the ASD Essential Eight Maturity Level 2 baseline for Australian organisations preparing for IRAP scope review.",
    "date": "Apr 8, 2026",
    "publishDate": "2026-04-08",
    "readTime": "22 min read",
    "category": "ACSC Essential Eight",
    "pillar": "Technology",
    "semanticCluster": "Copilot Essential Eight Alignment",
    "tags": [
      "Microsoft 365 Copilot",
      "Essential Eight",
      "Maturity Level 2",
      "ASD Blueprint",
      "IRAP",
      "Australian Cyber Security",
      "Copilot Control System"
    ],
    "status": "published",
    "source": "./2026-Q2/103-mapping-microsoft-365-copilot-asd-essential-eight-maturity-level-2-2026.mdx"
  },
  {
    "id": 102,
    "slug": "application-control-microsoft-365-applocker-wdac-ml2",
    "title": "Application Control on Microsoft 365: AppLocker and WDAC for ML2",
    "excerpt": "Practitioner walkthrough of deploying Essential Eight application control on a Microsoft 365 managed Windows fleet using AppLocker and Windows Defender Application Control to reach Maturity Level 2.",
    "date": "Apr 5, 2026",
    "publishDate": "2026-04-05",
    "readTime": "12 min read",
    "category": "Technology",
    "pillar": "Technology",
    "semanticCluster": "Essential Eight Maturity",
    "tags": [
      "Application Control",
      "AppLocker",
      "WDAC",
      "Microsoft 365",
      "Intune",
      "Essential Eight",
      "Maturity Level 2"
    ],
    "status": "published",
    "source": "./2026-Q2/102-application-control-microsoft-365-applocker-wdac-ml2.mdx"
  },
  {
    "id": 101,
    "slug": "essential-eight-ml2-evidence-templates-per-control",
    "title": "ML2 Evidence Templates per Essential Eight Control: A Practitioner Checklist",
    "excerpt": "Per-control evidence templates and assessor-ready checklists for Essential Eight Maturity Level 2, mapped to the November 2025 Information Security Manual and the ASD Maturity Model.",
    "date": "Apr 2, 2026",
    "publishDate": "2026-04-02",
    "readTime": "14 min read",
    "category": "Process",
    "pillar": "Process",
    "semanticCluster": "Essential Eight Maturity",
    "tags": [
      "Essential Eight",
      "Maturity Level 2",
      "Evidence",
      "ACSC",
      "ISM",
      "Assessment",
      "Audit"
    ],
    "status": "published",
    "source": "./2026-Q2/101-essential-eight-ml2-evidence-templates-per-control.mdx"
  },
  {
    "id": 100,
    "slug": "essential-eight-maturity-level-2-2026-evidence-pack",
    "title": "Essential Eight Maturity Level 2: The 2026 Evidence Pack",
    "excerpt": "Pillar guide to achieving ACSC Essential Eight Maturity Level 2 in 2026 — per-control evidence requirements, ISM mapping, assessor expectations and remediation sequencing for Australian organisations.",
    "date": "Mar 30, 2026",
    "publishDate": "2026-03-30",
    "readTime": "26 min read",
    "category": "ACSC Essential Eight",
    "pillar": "Technology",
    "semanticCluster": "Essential Eight Maturity",
    "tags": [
      "Essential Eight",
      "Maturity Level 2",
      "ACSC",
      "ASD",
      "ISM",
      "Evidence Collection",
      "Assessment"
    ],
    "status": "published",
    "source": "./2026-Q2/100-essential-eight-maturity-level-2-2026-evidence-pack.mdx"
  },
  {
    "id": 99,
    "slug": "copilot-adoption-kpis-first-90-days-australia",
    "title": "Copilot Adoption KPIs That Survive the First 90 Days in Australian Tenants",
    "excerpt": "The five Microsoft 365 Copilot adoption KPIs that survive the first 90 days in an Australian tenant — and the dashboards that defend them to a board.",
    "date": "Mar 27, 2026",
    "publishDate": "2026-03-27",
    "readTime": "7 min read",
    "category": "Microsoft 365",
    "pillar": "Technology",
    "semanticCluster": "Microsoft 365 Copilot Deployment",
    "tags": [
      "Microsoft Copilot",
      "Copilot Adoption",
      "Microsoft 365",
      "Australian Compliance",
      "Change Management"
    ],
    "status": "published",
    "source": "./2026-Q2/99-copilot-adoption-kpis-first-90-days-australia.mdx"
  },
  {
    "id": 98,
    "slug": "copilot-licensing-maths-australian-organisations",
    "title": "Copilot Licensing Maths for Australian Organisations: The AUD Cost Model",
    "excerpt": "Build a defensible Microsoft 365 Copilot AUD cost model for Australian organisations covering E3, E5, Business Premium, the add-on, E7, and Agent 365.",
    "date": "Mar 24, 2026",
    "publishDate": "2026-03-24",
    "readTime": "7 min read",
    "category": "Microsoft 365",
    "pillar": "Technology",
    "semanticCluster": "Microsoft 365 Copilot Deployment",
    "tags": [
      "Microsoft Copilot",
      "Copilot Licensing",
      "Microsoft 365",
      "Australian Compliance",
      "Cost Modelling"
    ],
    "status": "published",
    "source": "./2026-Q2/98-copilot-licensing-maths-australian-organisations.mdx"
  },
  {
    "id": 97,
    "slug": "microsoft-365-copilot-wave-3-deployment-playbook-australia",
    "title": "Microsoft 365 Copilot Wave 3 Deployment Playbook (Australia)",
    "excerpt": "A practitioner deployment playbook for Microsoft 365 Copilot Wave 3 in Australia. Licensing, tenant pre-flight, Researcher, Analyst, Work IQ, and adoption.",
    "date": "Mar 21, 2026",
    "publishDate": "2026-03-21",
    "readTime": "12 min read",
    "category": "Microsoft 365",
    "pillar": "Technology",
    "semanticCluster": "Microsoft 365 Copilot Deployment",
    "tags": [
      "Microsoft Copilot",
      "Copilot Deployment",
      "Microsoft 365",
      "Wave 3",
      "Australian Compliance",
      "Data Governance"
    ],
    "status": "published",
    "source": "./2026-Q2/97-microsoft-365-copilot-wave-3-deployment-playbook-australia.mdx"
  },
  {
    "id": 96,
    "slug": "backup-that-survives-ransomware-small-business-australia",
    "title": "Backup that survives ransomware — a small business guide for Australia 2026",
    "excerpt": "How Australian small businesses set up backups that actually survive a ransomware attack — immutability, offline copies, restore testing, and the evidence cyber insurers want.",
    "date": "Mar 18, 2026",
    "publishDate": "2026-03-18",
    "readTime": "8 min read",
    "category": "Technology",
    "pillar": "Technology",
    "semanticCluster": "SMB Cyber Baseline 2026",
    "tags": [
      "Backup",
      "Ransomware",
      "Immutability",
      "Small Business",
      "Microsoft 365 Backup",
      "Disaster Recovery",
      "Cyber Insurance"
    ],
    "status": "published",
    "source": "./2026-Q2/96-backup-that-survives-ransomware-small-business-australia.mdx"
  },
  {
    "id": 95,
    "slug": "mfa-for-tiny-teams-small-business-australia",
    "title": "MFA for tiny teams — how Australian small businesses turn on multi-factor authentication",
    "excerpt": "A plain-English guide to turning on multi-factor authentication for tiny Australian teams. Microsoft 365, Google Workspace, Xero, and MYOB — what to click and what evidence to keep.",
    "date": "Mar 15, 2026",
    "publishDate": "2026-03-15",
    "readTime": "10 min read",
    "category": "Technology",
    "pillar": "Technology",
    "semanticCluster": "SMB Cyber Baseline 2026",
    "tags": [
      "MFA",
      "Multi-Factor Authentication",
      "Small Business",
      "Microsoft 365",
      "Google Workspace",
      "Security Defaults",
      "Cyber Insurance"
    ],
    "status": "published",
    "source": "./2026-Q2/95-mfa-for-tiny-teams-small-business-australia.mdx"
  },
  {
    "id": 94,
    "slug": "cyber-insurance-underwriting-questions-small-business-australia",
    "title": "Cyber insurance underwriting questions — what Australian small businesses are asked in 2026",
    "excerpt": "The actual cyber insurance underwriting questions Australian small business owners face in 2026 — explained in plain English with the evidence underwriters expect for each answer.",
    "date": "Mar 12, 2026",
    "publishDate": "2026-03-12",
    "readTime": "11 min read",
    "category": "Compliance & Governance",
    "pillar": "Process",
    "semanticCluster": "SMB Cyber Baseline 2026",
    "tags": [
      "Cyber Insurance",
      "Underwriting",
      "Small Business",
      "Risk Management",
      "Australia",
      "Evidence Pack"
    ],
    "status": "published",
    "source": "./2026-Q2/94-cyber-insurance-underwriting-questions-small-business-australia.mdx"
  },
  {
    "id": 93,
    "slug": "ndb-scheme-plain-english-small-business-australia",
    "title": "Notifiable Data Breaches in plain English — what Australian small businesses must do",
    "excerpt": "The OAIC Notifiable Data Breaches scheme explained for Australian small business owners. Who is covered, the 30-day assessment clock, and the steps to take when a breach happens.",
    "date": "Mar 9, 2026",
    "publishDate": "2026-03-09",
    "readTime": "10 min read",
    "category": "Privacy & Compliance",
    "pillar": "Process",
    "semanticCluster": "SMB Cyber Baseline 2026",
    "tags": [
      "Notifiable Data Breaches",
      "OAIC",
      "Privacy Act",
      "Small Business",
      "Compliance",
      "Incident Response"
    ],
    "status": "published",
    "source": "./2026-Q2/93-ndb-scheme-plain-english-small-business-australia.mdx"
  },
  {
    "id": 92,
    "slug": "cyber-security-australian-small-business-practical-baseline-2026",
    "title": "Cyber Security Baseline for Australian Small Business (2026)",
    "excerpt": "A plain-English cyber security baseline for Australian small business owners in 2026. The ACSC-aligned controls, insurance underwriting answers, and Notifiable Data Breaches obligations explained without jargon.",
    "date": "Mar 6, 2026",
    "publishDate": "2026-03-06",
    "readTime": "15 min read",
    "category": "Security Culture",
    "pillar": "People",
    "semanticCluster": "SMB Cyber Baseline 2026",
    "tags": [
      "Small Business",
      "Cyber Security",
      "ACSC",
      "Notifiable Data Breaches",
      "Cyber Insurance",
      "Cyber Wardens",
      "Australian SMB"
    ],
    "status": "published",
    "source": "./2026-Q2/92-cyber-security-australian-small-business-practical-baseline-2026.mdx"
  },
  {
    "id": 91,
    "slug": "purview-dlp-for-copilot-australian-rollout-pattern",
    "title": "Purview DLP for Copilot Rollout — Australian Rollout Pattern",
    "excerpt": "A step-by-step Australian rollout pattern for Microsoft Purview Data Loss Prevention for Copilot, including pilot scoping, label coverage, and DSPM for AI tuning.",
    "date": "Mar 3, 2026",
    "publishDate": "2026-03-03",
    "readTime": "6 min read",
    "category": "Compliance & Governance",
    "pillar": "Technology",
    "semanticCluster": "Microsoft 365 Copilot Governance",
    "tags": [
      "Microsoft Purview",
      "DLP for Copilot",
      "Sensitivity Labels",
      "DSPM for AI",
      "Privacy Act"
    ],
    "status": "published",
    "source": "./2026-Q2/91-purview-dlp-for-copilot-australian-rollout-pattern.mdx"
  },
  {
    "id": 90,
    "slug": "agent-sprawl-audit-playbook-copilot-control-system",
    "title": "Agent Sprawl Audit Playbook — Copilot Control System Agent Inventory",
    "excerpt": "A practitioner playbook for auditing Copilot Studio agent sprawl using the Copilot Control System inventory, environment DLP, and connector allow-lists.",
    "date": "Feb 28, 2026",
    "publishDate": "2026-02-28",
    "readTime": "6 min read",
    "category": "Compliance & Governance",
    "pillar": "Process",
    "semanticCluster": "Microsoft 365 Copilot Governance",
    "tags": [
      "Microsoft Copilot",
      "Copilot Studio",
      "Agent Governance",
      "Copilot Control System",
      "How-To"
    ],
    "status": "published",
    "source": "./2026-Q2/90-agent-sprawl-audit-playbook-copilot-control-system.mdx"
  },
  {
    "id": 89,
    "slug": "copilot-governance-maturity-model-l1-l5-australia",
    "title": "The L1 to L5 Microsoft 365 Copilot Governance Maturity Model",
    "excerpt": "An Australian practitioner guide to the five-level Copilot governance maturity scale: Purview DLP, Copilot Studio agent governance, and APP 8 residency controls.",
    "date": "Feb 25, 2026",
    "publishDate": "2026-02-25",
    "readTime": "8 min read",
    "category": "Compliance & Governance",
    "pillar": "Process",
    "semanticCluster": "Microsoft 365 Copilot Governance",
    "tags": [
      "Microsoft Copilot",
      "Governance Maturity",
      "Purview DLP",
      "Copilot Studio",
      "Privacy Act"
    ],
    "status": "published",
    "source": "./2026-Q2/89-copilot-governance-maturity-model-l1-l5-australia.mdx"
  },
  {
    "id": 88,
    "slug": "dspm-for-ai-walkthrough-australian-copilot-rollout",
    "title": "DSPM for AI Walkthrough for an Australian Microsoft 365 Copilot Rollout",
    "excerpt": "Microsoft Purview DSPM for AI reached general availability in mid-2026. Walk through the configuration, alerts, and weekly cadence an Australian Copilot rollout actually needs.",
    "date": "Feb 22, 2026",
    "publishDate": "2026-02-22",
    "readTime": "8 min read",
    "category": "SharePoint Governance",
    "pillar": "Technology",
    "semanticCluster": "Microsoft 365 Copilot",
    "tags": [
      "Microsoft Purview",
      "DSPM for AI",
      "Microsoft Copilot",
      "SharePoint Governance",
      "Australian Compliance"
    ],
    "status": "published",
    "source": "./2026-Q2/88-dspm-for-ai-walkthrough-australian-copilot-rollout.mdx"
  },
  {
    "id": 87,
    "slug": "restricted-sharepoint-search-allow-list-curation-copilot-governance",
    "title": "Choosing Which SharePoint Sites to Restrict for Copilot (Australia)",
    "excerpt": "A guide to deciding which sites get Restricted Content Discovery or Restricted Access Control, and how to review them, now that Restricted SharePoint Search is retiring.",
    "date": "Feb 19, 2026",
    "publishDate": "2026-02-19",
    "readTime": "7 min read",
    "category": "SharePoint Governance",
    "pillar": "Technology",
    "semanticCluster": "Microsoft 365 Copilot",
    "tags": [
      "SharePoint Governance",
      "Microsoft Copilot",
      "Restricted Content Discovery",
      "Restricted Access Control",
      "Purview DSPM for AI",
      "Australian Compliance"
    ],
    "status": "published",
    "source": "./2026-Q2/87-restricted-sharepoint-search-allow-list-curation-copilot-governance.mdx"
  },
  {
    "id": 86,
    "slug": "entra-id-guest-external-access-hygiene",
    "title": "Entra ID Guest and External Access Hygiene for Australian Organisations",
    "excerpt": "How to harden Entra ID guest and external access — B2B invitation policy, cross-tenant access defaults, guest expiry, external sharing visibility — for Australian organisations under APP 6 and APP 11.",
    "date": "Feb 16, 2026",
    "publishDate": "2026-02-16",
    "readTime": "6 min read",
    "category": "Technology",
    "pillar": "Technology",
    "semanticCluster": "Entra ID Identity Assurance",
    "tags": [
      "Entra ID",
      "Guest Access",
      "B2B Collaboration",
      "Cross-Tenant Access",
      "External Identities",
      "Privacy Act"
    ],
    "status": "published",
    "source": "./2026-Q2/86-entra-id-guest-external-access-hygiene.mdx"
  },
  {
    "id": 85,
    "slug": "entra-id-access-reviews-implementation",
    "title": "Entra ID Access Reviews Implementation Guide for Australian Organisations",
    "excerpt": "How to design and run Microsoft Entra ID access reviews — privileged roles, group membership, guest accounts and application assignments — with the 2026 ML reviewer recommendations feature and ASD ISM alignment.",
    "date": "Feb 13, 2026",
    "publishDate": "2026-02-13",
    "readTime": "6 min read",
    "category": "Process",
    "pillar": "Process",
    "semanticCluster": "Entra ID Identity Assurance",
    "tags": [
      "Access Reviews",
      "Entra ID",
      "Identity Governance",
      "Privileged Identity Management",
      "Guest Access",
      "ACSC Essential Eight"
    ],
    "status": "published",
    "source": "./2026-Q2/85-entra-id-access-reviews-implementation.mdx"
  },
  {
    "id": 84,
    "slug": "privileged-identity-management-rollout-playbook",
    "title": "Privileged Identity Management Rollout Playbook for Australian Tenants",
    "excerpt": "A practitioner playbook for rolling out Microsoft Entra Privileged Identity Management — discovery, role design, eligibility, approval workflows, break- glass, and ASD ISM-1175 mapping for Australian organisations.",
    "date": "Feb 10, 2026",
    "publishDate": "2026-02-10",
    "readTime": "7 min read",
    "category": "Technology",
    "pillar": "Technology",
    "semanticCluster": "Entra ID Identity Assurance",
    "tags": [
      "Privileged Identity Management",
      "PIM",
      "Entra ID",
      "Just-In-Time",
      "ASD ISM",
      "ACSC Essential Eight"
    ],
    "status": "published",
    "source": "./2026-Q2/84-privileged-identity-management-rollout-playbook.mdx"
  },
  {
    "id": 83,
    "slug": "conditional-access-patterns-australian-organisations",
    "title": "Conditional Access Patterns for Australian Organisations: A 2026 How-To",
    "excerpt": "Step-by-step Conditional Access deployment patterns for Australian organisations — MFA-for-all, legacy auth block, sign-in risk, device compliance, session controls and token protection, mapped to ASD ISM.",
    "date": "Feb 7, 2026",
    "publishDate": "2026-02-07",
    "readTime": "6 min read",
    "category": "Technology",
    "pillar": "Technology",
    "semanticCluster": "Entra ID Identity Assurance",
    "tags": [
      "Conditional Access",
      "Entra ID",
      "MFA",
      "Identity Protection",
      "Continuous Access Evaluation",
      "ACSC Essential Eight"
    ],
    "status": "published",
    "source": "./2026-Q2/83-conditional-access-patterns-australian-organisations.mdx"
  },
  {
    "id": 82,
    "slug": "auditing-entra-id-australian-privacy-act",
    "title": "Auditing Entra ID for the Australian Privacy Act (2026)",
    "excerpt": "A comprehensive practitioner guide to auditing Microsoft Entra ID against the Australian Privacy Act and NDB scheme — privileged accounts, Conditional Access, guest access, and Identity Secure Score for Australian organisations.",
    "date": "Feb 4, 2026",
    "publishDate": "2026-02-04",
    "readTime": "10 min read",
    "category": "Privacy & Compliance",
    "pillar": "Technology",
    "semanticCluster": "Entra ID Identity Assurance",
    "tags": [
      "Entra ID",
      "Privacy Act",
      "NDB Scheme",
      "Conditional Access",
      "PIM",
      "Identity Secure Score",
      "ACSC Essential Eight"
    ],
    "status": "published",
    "source": "./2026-Q2/82-auditing-entra-id-australian-privacy-act.mdx"
  },
  {
    "id": 81,
    "slug": "restricted-sharepoint-search-australian-tenants",
    "title": "Restricted SharePoint Search Is Retiring: What Australian Tenants Should Do Now",
    "excerpt": "Microsoft is retiring Restricted SharePoint Search. Here is what it was, why it is going, what to use instead, and what to do if your tenant already enabled it.",
    "date": "Feb 1, 2026",
    "publishDate": "2026-02-01",
    "readTime": "7 min read",
    "category": "SharePoint Governance",
    "pillar": "Process",
    "semanticCluster": "Microsoft 365 Tenant Health",
    "tags": [
      "Restricted Content Discovery",
      "SharePoint",
      "Copilot",
      "Microsoft 365",
      "Governance",
      "SharePoint Advanced Management"
    ],
    "status": "published",
    "source": "./2026-Q2/81-restricted-sharepoint-search-australian-tenants.mdx"
  },
  {
    "id": 80,
    "slug": "microsoft-365-health-check-60-minutes",
    "title": "How to Run a Microsoft 365 Health Check in 60 Minutes (Australian SMB Walkthrough)",
    "excerpt": "A 60-minute self-directed Microsoft 365 health check for Australian SMB admins — identity, data, and tenant configuration, mapped to ACSC Essential Eight ML2 evidence and Copilot pre-deployment thresholds.",
    "date": "Jan 29, 2026",
    "publishDate": "2026-01-29",
    "readTime": "8 min read",
    "category": "Microsoft 365",
    "pillar": "Technology",
    "semanticCluster": "Microsoft 365 Tenant Health",
    "tags": [
      "Microsoft 365",
      "Tenant Health",
      "Essential Eight",
      "Secure Score",
      "ACSC",
      "Copilot Readiness"
    ],
    "status": "published",
    "source": "./2026-Q2/80-microsoft-365-health-check-60-minutes.mdx"
  },
  {
    "id": 79,
    "slug": "microsoft-secure-score-australian-smbs",
    "title": "Microsoft Secure Score for Australian SMBs: 2026 Guide",
    "excerpt": "How Australian small and mid-sized organisations should read, prioritise, and improve their Microsoft Secure Score against ACSC Essential Eight Maturity Level 2, with realistic Copilot-readiness thresholds and admin centre paths.",
    "date": "Jan 26, 2026",
    "publishDate": "2026-01-26",
    "readTime": "12 min read",
    "category": "Microsoft 365",
    "pillar": "Technology",
    "semanticCluster": "Microsoft 365 Tenant Health",
    "tags": [
      "Microsoft Secure Score",
      "Microsoft 365",
      "Essential Eight",
      "ACSC",
      "Copilot Readiness",
      "Australian SMB",
      "Purview"
    ],
    "status": "published",
    "source": "./2026-Q2/79-microsoft-secure-score-australian-smbs.mdx"
  },
  {
    "id": 78,
    "slug": "essential-eight-control-6-patch-operating-systems",
    "title": "Essential Eight Control 6: Patch Operating Systems — Windows, Linux and Server Implementation Guide",
    "excerpt": "Technical implementation guide for ACSC Essential Eight Control 6 covering OS patching maturity levels, Windows Update for Business, Microsoft Intune update rings, Linux unattended upgrades, server patching cycles, network OS firmware, and ACSC audit evidence for Australian organisations.",
    "date": "Jul 26, 2026",
    "publishDate": "2026-07-26",
    "readTime": "16 min read",
    "category": "ACSC Essential Eight",
    "pillar": "Technology",
    "semanticCluster": "Essential Eight Implementation",
    "tags": [
      "OS Patching",
      "Patch Management",
      "Essential Eight",
      "ACSC",
      "Windows Update",
      "Intune",
      "Server Patching"
    ],
    "status": "published",
    "source": "./2026-Q2/78-essential-eight-control-6-patch-operating-systems.mdx"
  },
  {
    "id": 77,
    "slug": "essential-eight-control-2-patch-applications",
    "title": "Essential Eight Control 2: Patch Applications Guide",
    "excerpt": "Technical implementation guide for ACSC Essential Eight Control 2 covering application patching timeframes across all three maturity levels, Intune and WSUS deployment, vulnerability scanning, evidence collection, and common pitfalls for Australian organisations.",
    "date": "Jan 23, 2026",
    "publishDate": "2026-07-20",
    "readTime": "19 min read",
    "category": "ACSC Essential Eight",
    "pillar": "Technology",
    "semanticCluster": "Essential Eight Implementation",
    "tags": [
      "Patch Management",
      "Application Patching",
      "Essential Eight",
      "ACSC",
      "Vulnerability Management",
      "Intune",
      "WSUS"
    ],
    "status": "published",
    "source": "./2026-Q2/77-essential-eight-control-2-patch-applications.mdx"
  },
  {
    "id": 76,
    "slug": "iso-27001-internal-audit-continuous-improvement-isms",
    "title": "ISO 27001 Internal Audits and Continual Improvement",
    "excerpt": "Learn how to design an annual internal audit programme, conduct nonconformity reporting, run management reviews, and sustain continual improvement to keep your ISO 27001 certification intact.",
    "date": "Jun 8, 2026",
    "publishDate": "2026-09-14",
    "readTime": "8 min read",
    "category": "Compliance & Governance",
    "pillar": "Process",
    "semanticCluster": "ISO 27001 and Compliance Governance",
    "tags": [
      "ISO 27001",
      "Internal Audit",
      "Continuous Improvement",
      "ISMS",
      "Compliance",
      "Risk Management"
    ],
    "status": "published",
    "source": "./2026-Q2/76-iso-27001-internal-audit-continuous-improvement-isms.mdx"
  },
  {
    "id": 75,
    "slug": "iso-27001-organisational-people-controls-annex-a5-a6",
    "title": "ISO 27001 Annex A.5 and A.6 Controls for Australia",
    "excerpt": "A practical guide to ISO 27001:2022 Annex A.5 organisational controls and A.6 people controls for Australian organisations, covering implementation priorities, documentation requirements, audit findings, and alignment with ACSC Essential Eight and Privacy Act 1988.",
    "date": "Jun 5, 2026",
    "publishDate": "2026-09-01",
    "readTime": "8 min read",
    "category": "Compliance & Governance",
    "pillar": "Process",
    "semanticCluster": "ISO 27001 and Compliance Governance",
    "tags": [
      "ISO 27001",
      "Annex A Controls",
      "Organisational Controls",
      "People Controls",
      "Compliance",
      "Privacy Act",
      "ACSC Essential Eight"
    ],
    "status": "published",
    "source": "./2026-Q2/75-iso-27001-organisational-people-controls-annex-a5-a6.mdx"
  },
  {
    "id": 74,
    "slug": "executive-board-security-engagement-cyber-risk-governance",
    "title": "Executive and Board-Level Security Engagement: Cyber Risk Governance for Australian Organisations",
    "excerpt": "How Australian boards and C-suites can close the cyber risk governance gap: translating technical risk into business language, building dashboards, meeting ASX and APRA CPS 234 obligations, and creating accountable security leadership.",
    "date": "Jun 3, 2026",
    "publishDate": "2026-05-19",
    "readTime": "8 min read",
    "category": "Security Culture",
    "pillar": "People",
    "semanticCluster": "Security Culture and Human Risk",
    "tags": [
      "Board Governance",
      "Cyber Risk",
      "Security Leadership",
      "APRA CPS 234",
      "Security Culture",
      "CISO"
    ],
    "status": "draft",
    "source": "./2026-Q2/74-executive-board-security-engagement-cyber-risk-governance.mdx"
  },
  {
    "id": 73,
    "slug": "building-incident-reporting-culture-no-blame-framework",
    "title": "Building an Incident Reporting Culture: The No-Blame Framework for Australian Organisations",
    "excerpt": "Why Australian staff under-report security incidents, how to build psychological safety, implement anonymous reporting, capture near-misses, design escalation workflows, and align with NDB scheme obligations under the Privacy Act 1988.",
    "date": "Jun 1, 2026",
    "publishDate": "2026-05-12",
    "readTime": "13 min read",
    "category": "Security Culture",
    "pillar": "People",
    "semanticCluster": "Security Culture and Human Risk",
    "tags": [
      "Incident Reporting",
      "No-Blame Culture",
      "Psychological Safety",
      "Privacy Act 1988",
      "Security Culture",
      "NDB Scheme"
    ],
    "status": "published",
    "source": "./2026-Q2/73-building-incident-reporting-culture-no-blame-framework.mdx"
  },
  {
    "id": 72,
    "slug": "azure-ad-b2b-guest-access-governance-australia",
    "title": "Azure AD B2B Guest Access Governance for Australian Organisations",
    "excerpt": "Unmanaged guest access is a leading cause of data exposure in Microsoft 365. This guide covers configuring external collaboration settings, Entitlement Management, access reviews, and Conditional Access for B2B guests in Australia.",
    "date": "Aug 14, 2026",
    "publishDate": "2026-08-14",
    "readTime": "8 min read",
    "category": "Azure Security",
    "pillar": "Technology",
    "semanticCluster": "Azure AD and Identity",
    "tags": [
      "Azure AD B2B",
      "Guest Access",
      "Identity Governance",
      "Conditional Access",
      "Privacy Act 1988"
    ],
    "status": "published",
    "source": "./2026-Q2/72-azure-ad-b2b-guest-access-governance-australia.mdx"
  },
  {
    "id": 71,
    "slug": "azure-ad-privileged-identity-management-jit-access",
    "title": "Azure AD Privileged Identity Management: Just-In-Time Admin Access for Australian Organisations",
    "excerpt": "Learn how Azure AD PIM eliminates standing admin privileges with Just-In-Time access, approval workflows, and time-bound elevation aligned to ACSC Essential Eight Control 5.",
    "date": "Aug 7, 2026",
    "publishDate": "2026-08-07",
    "readTime": "8 min read",
    "category": "Azure Security",
    "pillar": "Technology",
    "semanticCluster": "Azure AD and Identity",
    "tags": [
      "Azure AD PIM",
      "Just-In-Time Access",
      "Privileged Identity Management",
      "Essential Eight",
      "Zero Trust",
      "Identity Security"
    ],
    "status": "published",
    "source": "./2026-Q2/71-azure-ad-privileged-identity-management-jit-access.mdx"
  },
  {
    "id": 70,
    "slug": "essential-eight-control-3-microsoft-office-macro-settings",
    "title": "Essential Eight Control 3: Microsoft Office Macro Settings",
    "excerpt": "A technical guide to ACSC Essential Eight Control 3 - configuring Microsoft Office macro settings across Maturity Levels 1-3, Group Policy, Intune, VBA signing, trusted publishers, and evidence for ACSC assessments.",
    "date": "April 28, 2026",
    "publishDate": "2026-08-01",
    "readTime": "8 min read",
    "category": "ACSC Essential Eight",
    "pillar": "Technology",
    "semanticCluster": "Essential Eight Implementation",
    "tags": [
      "Essential Eight",
      "Microsoft Office",
      "Macro Security",
      "Group Policy",
      "Intune",
      "VBA",
      "ACSC"
    ],
    "status": "published",
    "source": "./2026-Q2/70-essential-eight-control-3-microsoft-office-macro-settings.mdx"
  },
  {
    "id": 69,
    "slug": "copilot-security-roadmap-essential-eight-australia",
    "title": "Building Your Copilot Security Roadmap: An Essential Eight-Aligned Framework for Australian Organisations",
    "excerpt": "A 90-day Essential Eight-aligned framework for enabling Microsoft 365 Copilot Wave 3 safely in Australian organisations, covering all eight controls and beyond.",
    "date": "Oct 28, 2026",
    "publishDate": "2026-10-28",
    "readTime": "11 min read",
    "category": "ACSC Essential Eight",
    "pillar": "Technology",
    "semanticCluster": "ACSC Essential Eight",
    "tags": [
      "ACSC Essential Eight",
      "Microsoft Copilot",
      "Zero Trust",
      "Australian Compliance",
      "Copilot Wave 3"
    ],
    "status": "published",
    "source": "./2026-Q3/69-copilot-security-roadmap-essential-eight-australia.mdx"
  },
  {
    "id": 68,
    "slug": "microsoft-365-copilot-australia-data-residency-irap",
    "title": "Australia Copilot Data Journey: IRAP, In-Country Processing, and What Is Still Missing",
    "excerpt": "Microsoft 365 Copilot in Australia is more than \"it is IRAP assessed\": the Copilot Cowork gap, APP 8 obligations and customer-side controls still demand governance.",
    "date": "Jul 21, 2026",
    "publishDate": "2026-07-21",
    "readTime": "10 min read",
    "category": "Compliance & Governance",
    "pillar": "Technology",
    "semanticCluster": "Microsoft 365 Copilot",
    "tags": [
      "Microsoft Copilot",
      "IRAP Assessment",
      "Data Residency",
      "Australian Compliance",
      "Privacy Act"
    ],
    "status": "published",
    "source": "./2026-Q3/68-microsoft-365-copilot-australia-data-residency-irap.mdx"
  },
  {
    "id": 67,
    "slug": "asd-blueprint-copilot-configuration-australia",
    "title": "ASD Blueprint Copilot Configuration Guide: A Practical Walkthrough for Australian Organisations",
    "excerpt": "A practical walkthrough of the ASD Blueprint Copilot configuration tiers and why Essential Eight alone does not secure Microsoft 365 Copilot deployments.",
    "date": "Oct 15, 2026",
    "publishDate": "2026-10-15",
    "readTime": "10 min read",
    "category": "ACSC Essential Eight",
    "pillar": "Technology",
    "semanticCluster": "ACSC Essential Eight",
    "tags": [
      "ASD Blueprint",
      "Microsoft Copilot",
      "Essential Eight",
      "Australian Compliance",
      "Data Governance"
    ],
    "status": "published",
    "source": "./2026-Q3/67-asd-blueprint-copilot-configuration-australia.mdx"
  },
  {
    "id": 66,
    "slug": "copilot-studio-2026-release-wave-australia",
    "title": "Copilot Studio 2026 Release Wave 1: Building Enterprise Agents for Australian Organisations",
    "excerpt": "Microsoft Copilot Studio 2026 Release Wave 1 introduces autonomous multi-agent orchestration, AI-powered governance, and full audit trails critical for Australian PSPF and ISM compliance.",
    "date": "Jul 7, 2026",
    "publishDate": "2026-07-07",
    "readTime": "8 min read",
    "category": "Technology",
    "pillar": "Technology",
    "semanticCluster": "Microsoft 365 Copilot",
    "tags": [
      "Microsoft Copilot",
      "Copilot Studio",
      "AI Agents",
      "Power Platform",
      "Australian Compliance"
    ],
    "status": "draft",
    "source": "./2026-Q3/66-copilot-studio-2026-release-wave-australia.mdx"
  },
  {
    "id": 65,
    "slug": "microsoft-work-iq-australian-privacy-implications",
    "title": "Microsoft Work IQ Explained: The Intelligence Layer and Its Australian Privacy Implications",
    "excerpt": "Microsoft Work IQ builds a persistent model of every employee. Australian organisations must assess Privacy Act obligations before enabling this intelligence layer.",
    "date": "Oct 3, 2026",
    "publishDate": "2026-10-03",
    "readTime": "8 min read",
    "category": "Privacy & Compliance",
    "pillar": "Technology",
    "semanticCluster": "Microsoft 365 Copilot",
    "tags": [
      "Microsoft Copilot",
      "Work IQ",
      "Privacy Act",
      "Australian Compliance",
      "AI Governance"
    ],
    "status": "published",
    "source": "./2026-Q2/65-microsoft-work-iq-australian-privacy-implications.mdx"
  },
  {
    "id": 64,
    "slug": "microsoft-365-copilot-business-smb-australia",
    "title": "Microsoft 365 Copilot Business: The Complete Guide for Australian Small Businesses",
    "excerpt": "Microsoft 365 Copilot Business brings enterprise-grade AI to Australian SMBs under 300 users. Here is what it costs, what it includes, and how to deploy it safely.",
    "date": "Sep 27, 2026",
    "publishDate": "2026-09-27",
    "readTime": "7 min read",
    "category": "Microsoft 365",
    "pillar": "Technology",
    "semanticCluster": "Microsoft 365 Copilot",
    "tags": [
      "Microsoft Copilot",
      "Microsoft 365",
      "SMB Cybersecurity",
      "Australian Compliance",
      "Data Governance"
    ],
    "status": "published",
    "source": "./2026-Q2/64-microsoft-365-copilot-business-smb-australia.mdx"
  },
  {
    "id": 63,
    "slug": "copilot-cowork-australia-data-residency-gap",
    "title": "Copilot Cowork and the Data Residency Problem Australian Organisations Must Understand",
    "excerpt": "Microsoft Copilot Cowork routes task execution through Anthropic Claude, which sits outside Australian in-country processing guarantees. Here is what that means.",
    "date": "May 18, 2026",
    "publishDate": "2026-06-02",
    "readTime": "9 min read",
    "category": "Compliance & Governance",
    "pillar": "Technology",
    "semanticCluster": "Microsoft 365 Copilot",
    "tags": [
      "Microsoft Copilot",
      "Data Residency",
      "Privacy Act",
      "Copilot Wave 3",
      "Australian Compliance"
    ],
    "status": "published",
    "source": "./2026-Q2/63-copilot-cowork-australia-data-residency-gap.mdx"
  },
  {
    "id": 62,
    "slug": "microsoft-copilot-sharepoint-teams-governance-australia",
    "title": "AI in SharePoint and Teams: What Copilot Wave 3 Means for Australian Intranet Governance",
    "excerpt": "Copilot quality depends on SharePoint quality. With AI in SharePoint rolling out across Microsoft 365 from early 2026, Australian organisations must fix permissions and metadata.",
    "date": "Sep 20, 2026",
    "publishDate": "2026-09-20",
    "readTime": "8 min read",
    "category": "SharePoint Governance",
    "pillar": "Technology",
    "semanticCluster": "Microsoft 365 Copilot",
    "tags": [
      "SharePoint Governance",
      "Microsoft Copilot",
      "Microsoft Teams",
      "AI Governance",
      "Australian Compliance"
    ],
    "status": "published",
    "source": "./2026-Q2/62-microsoft-copilot-sharepoint-teams-governance-australia.mdx"
  },
  {
    "id": 61,
    "slug": "microsoft-purview-copilot-sensitivity-labels-australia",
    "title": "Microsoft Purview and Copilot: Protecting Australian Data in the Agentic Era",
    "excerpt": "How Microsoft Purview sensitivity labels and DLP policies govern Copilot access to Australian data, the June 2026 agent coverage gap, and what to configure now.",
    "date": "Jan 20, 2026",
    "publishDate": "2026-01-20",
    "readTime": "9 min read",
    "category": "Compliance & Governance",
    "pillar": "Technology",
    "semanticCluster": "Microsoft 365 Copilot",
    "tags": [
      "Microsoft Purview",
      "Sensitivity Labels",
      "Microsoft Copilot",
      "Data Protection",
      "Privacy Act"
    ],
    "status": "published",
    "source": "./2026-Q2/61-microsoft-purview-copilot-sensitivity-labels-australia.mdx"
  },
  {
    "id": 60,
    "slug": "agent-365-frontier-suite-governance-australia",
    "title": "Agent 365 and the Frontier Suite: A Governance Guide for Australian IT Leaders",
    "excerpt": "Microsoft announced Agent 365 at Ignite 2025 as a control plane for AI agents. Here is what Australian IT leaders should govern before enabling agents across Microsoft 365.",
    "date": "Jan 17, 2026",
    "publishDate": "2026-01-17",
    "readTime": "10 min read",
    "category": "Compliance & Governance",
    "pillar": "Technology",
    "semanticCluster": "Microsoft 365 Copilot",
    "tags": [
      "Agent 365",
      "Microsoft 365",
      "Copilot Wave 3",
      "Zero Trust",
      "ACSC Essential Eight"
    ],
    "status": "published",
    "source": "./2026-Q2/60-agent-365-frontier-suite-governance-australia.mdx"
  },
  {
    "id": 59,
    "slug": "copilot-agentic-features-apps-2026",
    "title": "Copilot Agentic Features in Word, Excel, PowerPoint and Outlook: What Is Live Right Now",
    "excerpt": "A practical status check on Microsoft 365 Copilot agentic features across Word, Excel, PowerPoint and Outlook, and the governance controls Australian organisations must configure first.",
    "date": "Jan 14, 2026",
    "publishDate": "2026-01-14",
    "readTime": "9 min read",
    "category": "Governance & Risk",
    "pillar": "Technology",
    "semanticCluster": "Microsoft 365 Copilot",
    "tags": [
      "Microsoft Copilot",
      "Microsoft 365",
      "Copilot Wave 3",
      "Data Governance",
      "Sensitivity Labels"
    ],
    "status": "draft",
    "source": "./2026-Q2/59-copilot-agentic-features-apps-2026.mdx"
  },
  {
    "id": 58,
    "slug": "microsoft-copilot-wave-3-australian-briefing",
    "title": "Microsoft Copilot Wave 3: The Complete Australian IT Leader Briefing",
    "excerpt": "Microsoft Copilot Wave 3 makes AI autonomous. Australian IT leaders need a governance decision before enabling Agent 365, Copilot Cowork, and the Frontier Suite.",
    "date": "Jan 11, 2026",
    "publishDate": "2026-01-11",
    "readTime": "9 min read",
    "category": "Microsoft 365",
    "pillar": "Technology",
    "semanticCluster": "Microsoft 365 Copilot",
    "tags": [
      "Microsoft Copilot",
      "Microsoft 365",
      "Copilot Wave 3",
      "Zero Trust",
      "Australian Compliance"
    ],
    "status": "published",
    "source": "./2026-Q2/58-microsoft-copilot-wave-3-australian-briefing.mdx"
  },
  {
    "id": 57,
    "slug": "microsoft-copilot-researcher-analyst-agents-australia",
    "title": "Microsoft 365 Copilot Researcher and Analyst Agents: A Practical Guide for Australian Organisations",
    "excerpt": "A practical guide to Microsoft 365 Copilot Researcher and Analyst agents for Australian organisations, covering Wave 3 Critique mode and data governance.",
    "date": "Jan 8, 2026",
    "publishDate": "2026-01-08",
    "readTime": "8 min read",
    "category": "Technology",
    "pillar": "Technology",
    "semanticCluster": "Microsoft 365 Copilot",
    "tags": [
      "Microsoft Copilot",
      "AI Agents",
      "Microsoft 365",
      "Data Analysis",
      "Australian Compliance"
    ],
    "status": "published",
    "source": "./2026-Q2/57-microsoft-copilot-researcher-analyst-agents-australia.mdx"
  },
  {
    "id": 56,
    "slug": "microsoft-365-copilot-wave-2-australian-guide",
    "title": "Microsoft 365 Copilot Wave 2: Pages, Agents, and What Australian IT Leaders Missed",
    "excerpt": "Microsoft 365 Copilot Wave 2 reshaped AI at work with Pages, SharePoint agents, and the Copilot Control System. Australian IT leaders need this technical guide.",
    "date": "Jan 5, 2026",
    "publishDate": "2026-01-05",
    "readTime": "9 min read",
    "category": "Microsoft 365",
    "pillar": "Technology",
    "semanticCluster": "Microsoft 365 Copilot",
    "tags": [
      "Microsoft Copilot",
      "Microsoft 365",
      "Copilot Wave 2",
      "SharePoint Governance",
      "Australian Compliance"
    ],
    "status": "published",
    "source": "./2026-Q2/56-microsoft-365-copilot-wave-2-australian-guide.mdx"
  },
  {
    "id": 55,
    "slug": "microsoft-365-copilot-wave-1-australian-guide",
    "title": "Microsoft 365 Copilot Wave 1: What the GA Launch Meant for Australian Organisations",
    "excerpt": "A definitive Australian guide to Microsoft 365 Copilot Wave 1: GA launch, governance, IRAP, ASD Blueprint, and the permissions inheritance that changed M365.",
    "date": "Jan 2, 2026",
    "publishDate": "2026-01-02",
    "readTime": "8 min read",
    "category": "Microsoft 365",
    "pillar": "Technology",
    "semanticCluster": "Microsoft 365 Copilot",
    "tags": [
      "Microsoft Copilot",
      "Microsoft 365",
      "Copilot Wave 1",
      "Australian Compliance",
      "Data Governance"
    ],
    "status": "published",
    "source": "./2026-Q2/55-microsoft-365-copilot-wave-1-australian-guide.mdx"
  },
  {
    "id": 54,
    "slug": "educ4te-training-advisory-capabilities-showcase",
    "title": "EDUC4TE Training & Advisory Capabilities: Your Partner in Cybersecurity Excellence",
    "excerpt": "Discover how EDUC4TE combines world-class training programs with expert advisory services to deliver end-to-end cybersecurity solutions for Australian enterprises—from initial assessment through ongoing compliance.",
    "date": "Dec 30, 2025",
    "publishDate": "2025-12-30",
    "readTime": "13 min read",
    "category": "Compliance & Governance",
    "pillar": "Technology",
    "semanticCluster": "EDUC4TE Services",
    "tags": [
      "Training",
      "Advisory Services",
      "Essential Eight",
      "Microsoft 365",
      "Compliance",
      "Security Assessment",
      "Cybersecurity"
    ],
    "status": "published",
    "source": "./2026-Q1/54-educ4te-training-advisory-capabilities-showcase.mdx"
  },
  {
    "id": 53,
    "slug": "complete-sharepoint-2026-migration-checklist-assessment-to-go-live",
    "title": "The Complete SharePoint 2026 Migration Checklist: From Assessment to Go-Live",
    "excerpt": "A comprehensive end-to-end migration checklist for SharePoint modernisation after the 2026 retirement and support milestones, covering assessment, planning, execution, testing and go-live.",
    "date": "Dec 27, 2025",
    "publishDate": "2025-12-27",
    "readTime": "12 min read",
    "category": "SharePoint Governance",
    "pillar": "Process",
    "semanticCluster": "SharePoint 2026 Modernization & Migration",
    "tags": [
      "SharePoint Migration",
      "Project Management",
      "Migration Checklist",
      "Change Management",
      "Go-Live"
    ],
    "status": "published",
    "source": "./2026-Q2/53-complete-sharepoint-2026-migration-checklist-assessment-to-go-live.mdx"
  },
  {
    "id": 52,
    "slug": "sharepoint-agents-agentic-ai-preparing-environment-autonomous-workflows",
    "title": "SharePoint Agents and Agentic AI: Preparing Your Environment for Autonomous Workflows",
    "excerpt": "SharePoint Agents introduce autonomous AI decision-making in 2026. Learn how to prepare governance, permissions, and security controls for AI-driven workflows in Australian organisations.",
    "date": "Dec 24, 2025",
    "publishDate": "2025-12-24",
    "readTime": "7 min read",
    "category": "SharePoint Governance",
    "pillar": "Technology",
    "semanticCluster": "SharePoint 2026 Modernization & Migration",
    "tags": [
      "SharePoint Agents",
      "Agentic AI",
      "AI Governance",
      "Autonomous Workflows",
      "Copilot",
      "Zero Trust"
    ],
    "status": "published",
    "source": "./2026-Q2/52-sharepoint-agents-agentic-ai-preparing-environment-autonomous-workflows.mdx"
  },
  {
    "id": 51,
    "slug": "file-level-archiving-sharepoint-2026-storage-optimisation-without-data-loss",
    "title": "File-Level Archiving in SharePoint 2026: Storage Optimisation Without Data Loss",
    "excerpt": "SharePoint and Microsoft 365 Archive move inactive content to a lower-cost cold storage tier, reducing storage spend while maintaining compliance. Learn the Australian compliance implications.",
    "date": "Dec 21, 2025",
    "publishDate": "2025-12-21",
    "readTime": "6 min read",
    "category": "SharePoint Governance",
    "pillar": "Technology",
    "semanticCluster": "SharePoint 2026 Modernization & Migration",
    "tags": [
      "SharePoint Archiving",
      "Storage Optimisation",
      "Compliance",
      "Cost Reduction",
      "Retention Policies"
    ],
    "status": "published",
    "source": "./2026-Q2/51-file-level-archiving-sharepoint-2026-storage-optimisation-without-data-loss.mdx"
  },
  {
    "id": 50,
    "slug": "microsoft-purview-sharepoint-governance-transition-compliance-officers",
    "title": "Microsoft Purview for SharePoint: The Governance Transition Every Compliance Officer Must Navigate",
    "excerpt": "Microsoft Purview provides the current cross-service home for DLP, eDiscovery, retention and audit. Assess legacy SharePoint configurations and consolidate governance without assuming an unsupported blanket retirement.",
    "date": "Dec 18, 2025",
    "publishDate": "2025-12-18",
    "readTime": "11 min read",
    "category": "SharePoint Governance",
    "pillar": "Technology",
    "semanticCluster": "SharePoint 2026 Modernization & Migration",
    "tags": [
      "Microsoft Purview",
      "SharePoint Governance",
      "Data Loss Prevention",
      "eDiscovery",
      "Compliance",
      "Privacy Act"
    ],
    "status": "published",
    "source": "./2026-Q2/50-microsoft-purview-sharepoint-governance-transition-compliance-officers.mdx"
  },
  {
    "id": 49,
    "slug": "sharepoint-server-subscription-edition-on-premises-path-2026",
    "title": "SharePoint Server Subscription Edition: The On-Premises Path That Still Makes Sense in 2026",
    "excerpt": "After SharePoint 2016/2019 support ended on 14 July 2026, SharePoint Server Subscription Edition (SPSE) provides a modern on-premises option for air-gapped environments, data sovereignty, and legacy app dependencies.",
    "date": "Dec 15, 2025",
    "publishDate": "2025-12-15",
    "readTime": "10 min read",
    "category": "SharePoint Governance",
    "pillar": "Technology",
    "semanticCluster": "SharePoint 2026 Modernization & Migration",
    "tags": [
      "SharePoint Subscription Edition",
      "On-Premises SharePoint",
      "Data Sovereignty",
      "Air-Gapped Environments",
      "SPSE"
    ],
    "status": "published",
    "source": "./2026-Q2/49-sharepoint-server-subscription-edition-on-premises-path-2026.mdx"
  },
  {
    "id": 48,
    "slug": "new-sharepoint-online-experience-what-changed-why-cisos-should-care",
    "title": "The New SharePoint Online Experience: What Changed and Why CISOs Should Care",
    "excerpt": "SharePoint Online 2026 introduces Agentic AI, SharePoint Agents, modernised UI, and new security controls. Understand the governance and security implications for Australian enterprises.",
    "date": "Dec 12, 2025",
    "publishDate": "2025-12-12",
    "readTime": "10 min read",
    "category": "SharePoint Governance",
    "pillar": "Technology",
    "semanticCluster": "SharePoint 2026 Modernization & Migration",
    "tags": [
      "SharePoint Online",
      "Agentic AI",
      "SharePoint Agents",
      "Microsoft Copilot",
      "Zero Trust"
    ],
    "status": "published",
    "source": "./2026-Q2/48-new-sharepoint-online-experience-what-changed-why-cisos-should-care.mdx"
  },
  {
    "id": 47,
    "slug": "sharepoint-hybrid-cloud-only-2026-decision-framework-australian-enterprises",
    "title": "SharePoint Hybrid vs. Cloud-Only: The 2026 Decision Framework for Australian Enterprises",
    "excerpt": "With SharePoint 2016/2019 end-of-support on July 14, Australian organisations face a critical architecture decision: hybrid, cloud-only, or Subscription Edition. Learn the cost, compliance, and sovereignty considerations.",
    "date": "Dec 9, 2025",
    "publishDate": "2025-12-09",
    "readTime": "11 min read",
    "category": "SharePoint Governance",
    "pillar": "Technology",
    "semanticCluster": "SharePoint 2026 Modernization & Migration",
    "tags": [
      "SharePoint Hybrid",
      "SharePoint Online",
      "Cloud Migration",
      "Data Sovereignty",
      "SharePoint Subscription Edition"
    ],
    "status": "published",
    "source": "./2026-Q2/47-sharepoint-hybrid-cloud-only-2026-decision-framework-australian-enterprises.mdx"
  },
  {
    "id": 46,
    "slug": "infopath-end-of-life-powerapps-migration-strategies-australian-compliance",
    "title": "InfoPath End-of-Life: PowerApps Migration Strategies for Australian Compliance",
    "excerpt": "Assess InfoPath after the July 2026 SharePoint Online removal and on-premises support changes, then migrate forms to Power Apps while preserving required records.",
    "date": "Dec 6, 2025",
    "publishDate": "2025-12-06",
    "readTime": "10 min read",
    "category": "SharePoint Governance",
    "pillar": "Technology",
    "semanticCluster": "SharePoint 2026 Modernization & Migration",
    "tags": [
      "InfoPath Retirement",
      "PowerApps",
      "Forms Migration",
      "Privacy Act",
      "Compliance",
      "SharePoint Forms"
    ],
    "status": "published",
    "source": "./2026-Q2/46-infopath-end-of-life-powerapps-migration-strategies-australian-compliance.mdx"
  },
  {
    "id": 45,
    "slug": "from-2013-workflows-power-automate-3-week-migration-survival-guide",
    "title": "From 2013 Workflows to Power Automate: Your 3-Week Migration Survival Guide",
    "excerpt": "Use this 3-week remediation framework to move remaining SharePoint 2013 Workflows to Power Automate after the 2026 retirement milestones.",
    "date": "Dec 3, 2025",
    "publishDate": "2025-12-03",
    "readTime": "10 min read",
    "category": "SharePoint Governance",
    "pillar": "Technology",
    "semanticCluster": "SharePoint 2026 Modernization & Migration",
    "tags": [
      "Power Automate",
      "Workflow Migration",
      "SharePoint 2013",
      "Business Process Automation",
      "SharePoint Online"
    ],
    "status": "published",
    "source": "./2026-Q2/45-from-2013-workflows-power-automate-3-week-migration-survival-guide.mdx"
  },
  {
    "id": 44,
    "slug": "sharepoint-2026-retirement-deadline-every-australian-organisation-must-know",
    "title": "SharePoint 2026: The Retirement Deadline Every Australian Organisation Must Know",
    "excerpt": "Review the SharePoint changes that took effect during 2026, including the Add-in and Azure ACS retirement, SharePoint Alerts removal, InfoPath support changes and SharePoint Server 2016/2019 end of support.",
    "date": "Nov 30, 2025",
    "publishDate": "2025-11-30",
    "readTime": "9 min read",
    "category": "SharePoint Governance",
    "pillar": "Technology",
    "semanticCluster": "SharePoint 2026 Modernization & Migration",
    "tags": [
      "SharePoint 2026",
      "Migration",
      "Workflow Retirement",
      "InfoPath EOL",
      "Azure ACS",
      "Power Automate"
    ],
    "status": "published",
    "source": "./2026-Q2/44-sharepoint-2026-retirement-deadline-every-australian-organisation-must-know.mdx"
  },
  {
    "id": 43,
    "slug": "sam-masterclass-ebook-governing-m365-in-the-age-of-copilot",
    "title": "The SharePoint Advanced Management Masterclass Guide: Governing Microsoft 365 in the Age of Copilot",
    "excerpt": "A complete IT leader and CISO guide to SharePoint Advanced Management — from governance fundamentals and security hardening to Copilot readiness, licensing strategy, a 10-point health check, and essential PowerShell scripts.",
    "date": "Nov 27, 2025",
    "publishDate": "2025-11-27",
    "readTime": "35 min read",
    "category": "Ebook",
    "pillar": "Technology",
    "semanticCluster": "SharePoint Advanced Management",
    "tags": [
      "SharePoint Advanced Management",
      "M365 Governance",
      "Microsoft Copilot",
      "Data Access Governance",
      "Restricted Access Control",
      "SharePoint Advanced Management Licensing",
      "CISO Guide"
    ],
    "status": "published",
    "source": "./2026-Q1/43-sam-masterclass-ebook-governing-m365-in-the-age-of-copilot.mdx"
  },
  {
    "id": 42,
    "slug": "sam-licensing-decoded-maximising-roi-m365-2026",
    "title": "SharePoint Advanced Management Licensing Decoded: Maximising ROI in the 2026 M365 Ecosystem",
    "excerpt": "The retirement of standalone SharePoint and OneDrive plans, announced January 2026, changes the M365 licensing calculus. Here is how to maximise SharePoint Advanced Management ROI and avoid paying twice for the same governance capability.",
    "date": "Nov 24, 2025",
    "publishDate": "2025-11-24",
    "readTime": "10 min read",
    "category": "Microsoft 365",
    "pillar": "Technology",
    "semanticCluster": "SharePoint Advanced Management",
    "tags": [
      "SharePoint Advanced Management Licensing",
      "M365 Licensing Strategy",
      "SharePoint Advanced Management",
      "Microsoft 365 Copilot",
      "Licensing ROI"
    ],
    "status": "published",
    "source": "./2026-Q1/42-sam-licensing-decoded-maximising-roi-m365-2026.mdx"
  },
  {
    "id": 41,
    "slug": "content-copilot-ready-sharepoint-advanced-management",
    "title": "Is Your Content Copilot-Ready? Cleaning the Ranks with SharePoint Advanced Management",
    "excerpt": "Microsoft 365 Copilot surfaces whatever your users can access — including dark data, outdated records, and sensitive files in orphaned sites. SharePoint Advanced Management is the governance layer that makes Copilot safe to deploy at scale.",
    "date": "Nov 21, 2025",
    "publishDate": "2025-11-21",
    "readTime": "10 min read",
    "category": "Microsoft 365",
    "pillar": "Technology",
    "semanticCluster": "SharePoint Advanced Management",
    "tags": [
      "Microsoft Copilot",
      "SharePoint Advanced Management",
      "Dark Data",
      "M365 AI Readiness",
      "Copilot Governance",
      "Data Governance"
    ],
    "status": "published",
    "source": "./2026-Q1/41-content-copilot-ready-sharepoint-advanced-management.mdx"
  },
  {
    "id": 40,
    "slug": "hardening-hub-sam-stop-data-over-sharing-2026",
    "title": "Hardening the Hub: Using SharePoint Advanced Management to Stop Data Over-Sharing in 2026",
    "excerpt": "Data Access Governance reports and Restricted Access Control in SharePoint Advanced Management give Australian IT teams the tools they need to eliminate over-sharing before it becomes a breach.",
    "date": "Nov 18, 2025",
    "publishDate": "2025-11-18",
    "readTime": "10 min read",
    "category": "Microsoft 365",
    "pillar": "Technology",
    "semanticCluster": "SharePoint Advanced Management",
    "tags": [
      "Data Access Governance",
      "SharePoint Security",
      "Restricted Access Control",
      "M365 Governance",
      "Privacy Act",
      "Over-sharing Prevention"
    ],
    "status": "published",
    "source": "./2026-Q1/40-hardening-hub-sam-stop-data-over-sharing-2026.mdx"
  },
  {
    "id": 39,
    "slug": "beyond-standard-sharepoint-sam-governance-puzzle",
    "title": "Beyond Standard SharePoint: Why SharePoint Advanced Management is the Missing Piece of Your Governance Puzzle",
    "excerpt": "SharePoint sprawl is costing Australian organisations in compliance risk and productivity. Discover how SharePoint Advanced Management closes the governance gap standard licensing leaves behind.",
    "date": "Nov 15, 2025",
    "publishDate": "2025-11-15",
    "readTime": "9 min read",
    "category": "Microsoft 365",
    "pillar": "Technology",
    "semanticCluster": "SharePoint Advanced Management",
    "tags": [
      "SharePoint Advanced Management",
      "M365 Governance",
      "Site Lifecycle Management",
      "Content Sprawl",
      "ACSC",
      "Privacy Act"
    ],
    "status": "published",
    "source": "./2026-Q1/39-beyond-standard-sharepoint-sam-governance-puzzle.mdx"
  },
  {
    "id": 38,
    "slug": "conditional-access-policies-for-zero-trust",
    "title": "Conditional Access Policies for Zero Trust: A Comprehensive Guide",
    "excerpt": "A comprehensive technical guide to implementing Conditional Access Policies for Zero Trust for Australian organisations, aligned with ACSC Essential Eight and real-world deployment strategies.",
    "date": "Nov 12, 2025",
    "publishDate": "2025-11-12",
    "readTime": "18 min read",
    "category": "ACSC Essential Eight",
    "pillar": "Technology",
    "semanticCluster": "Conditional Access Policies for Zero Trust Implementation",
    "tags": [
      "Conditional Access Policies for Zero Trust",
      "ACSC",
      "Essential Eight",
      "Compliance"
    ],
    "status": "published",
    "source": "./2026-Q1/38-conditional-access-policies-for-zero-trust.mdx"
  },
  {
    "id": 36,
    "slug": "security-culture-foundations-building-workforce-ready-acsc",
    "title": "Security Culture Foundations: Building a Workforce Ready for ACSC",
    "excerpt": "A practitioner guide for CISOs, HR leaders and executives on building a security-aware Australian workforce aligned to ACSC Essential Eight and the Privacy Act 1988.",
    "date": "Nov 9, 2025",
    "publishDate": "2025-11-09",
    "readTime": "10 min read",
    "category": "Security Culture",
    "pillar": "People",
    "semanticCluster": "Security Culture and ACSC Alignment",
    "tags": [
      "security culture",
      "awareness training",
      "ACSC",
      "Essential Eight"
    ],
    "status": "published",
    "source": "./2026-Q1/36-security-culture-foundations-building-workforce-ready-acsc.mdx"
  },
  {
    "id": 35,
    "slug": "third-party-risk-management-vendor-security",
    "title": "Third-Party Risk Management: Assessing Vendor Security for Australian Organisations",
    "excerpt": "Comprehensive third-party risk assessment framework covering vendor security questionnaires, contract requirements, ongoing monitoring, supply chain attack lessons from SolarWinds and Log4j, and Australian cloud provider evaluation for organisations managing supplier cyber risk.",
    "date": "Nov 6, 2025",
    "publishDate": "2025-11-06",
    "readTime": "9 min read",
    "category": "Compliance & Governance",
    "pillar": "People",
    "semanticCluster": "Risk Management",
    "tags": [
      "Vendor Risk",
      "Supply Chain Security",
      "Third-Party Risk",
      "Supplier Management",
      "Cloud Security"
    ],
    "status": "published",
    "source": "./2026-Q1/35-third-party-risk-management-vendor-security.mdx"
  },
  {
    "id": 34,
    "slug": "incident-response-planning-template",
    "title": "Incident Response Planning: Build Your Cyber Security Playbook",
    "excerpt": "Practical incident response framework for Australian organisations covering NIST 6-phase playbook, roles and responsibilities, communication templates, Notifiable Data Breaches notification requirements, and ransomware-specific response procedures.",
    "date": "Nov 3, 2025",
    "publishDate": "2025-11-03",
    "readTime": "9 min read",
    "category": "Compliance & Governance",
    "pillar": "Process",
    "semanticCluster": "Security Operations",
    "tags": [
      "Incident Response",
      "Crisis Management",
      "Breach Response",
      "Playbook",
      "NIST",
      "NDB"
    ],
    "status": "published",
    "source": "./2026-Q1/34-incident-response-planning-template.mdx"
  },
  {
    "id": 33,
    "slug": "privacy-act-1988-compliance-guide-australian-organisations",
    "title": "Privacy Act 1988 Compliance Guide for Australian Organisations",
    "excerpt": "Comprehensive guide to Australian Privacy Principles (APPs), Notifiable Data Breaches scheme, reasonable security steps obligations, cross-border data disclosure requirements, and OAIC enforcement for Australian organisations handling personal information.",
    "date": "Oct 31, 2025",
    "publishDate": "2025-10-31",
    "readTime": "10 min read",
    "category": "Compliance & Governance",
    "pillar": "Process",
    "semanticCluster": "Australian Compliance",
    "tags": [
      "Privacy Act",
      "Data Protection",
      "Compliance",
      "Australian Law",
      "APPs",
      "OAIC"
    ],
    "status": "published",
    "source": "./2026-Q1/33-privacy-act-1988-compliance-guide-australian-organisations.mdx"
  },
  {
    "id": 32,
    "slug": "regular-backups-recovery-essential-eight",
    "title": "Essential Eight Control 8: Regular Backups & Ransomware Recovery",
    "excerpt": "Technical implementation guide for Essential Eight Control 8 covering 3-2-1-1 backup strategy, immutability requirements for Level 3 maturity, Azure Backup, Veeam configuration, testing procedures, and ransomware recovery playbooks for Australian organisations.",
    "date": "Oct 28, 2025",
    "publishDate": "2025-10-28",
    "readTime": "9 min read",
    "category": "ACSC Essential Eight",
    "pillar": "Technology",
    "semanticCluster": "Essential Eight Implementation",
    "tags": [
      "Backup",
      "Disaster Recovery",
      "Essential Eight",
      "Ransomware",
      "3-2-1 Rule",
      "Azure Backup"
    ],
    "status": "published",
    "source": "./2026-Q1/32-regular-backups-recovery-essential-eight.mdx"
  },
  {
    "id": 31,
    "slug": "system-monitoring-logging-siem",
    "title": "System Monitoring, Logging & SIEM: Building a Security Operations Foundation",
    "excerpt": "A practical guide to implementing system monitoring, logging, and SIEM for Australian organisations—covering compliance, threat detection, and operational best practices.",
    "date": "Oct 25, 2025",
    "publishDate": "2025-10-25",
    "category": "Technology",
    "pillar": "Technology",
    "semanticCluster": "Security Operations",
    "tags": [
      "SIEM",
      "Logging",
      "Monitoring",
      "Threat Detection",
      "Security Operations"
    ],
    "status": "published",
    "source": "./2026-Q1/31-system-monitoring-logging-siem.mdx"
  },
  {
    "id": 30,
    "slug": "application-hardening-browser-office-security",
    "title": "Application Hardening: Browser Security, Office Hardening, and Plugin Management",
    "excerpt": "Deep dive into ACSC Essential Eight Control 4 (Malware Protection): browser hardening (Edge, Chrome, Firefox), Office macro controls, PDF reader security, removal of Java/Flash, plugin management, and application-level security controls.",
    "date": "Oct 22, 2025",
    "publishDate": "2025-10-22",
    "readTime": "12 min read",
    "category": "ACSC Essential Eight",
    "pillar": "Technology",
    "semanticCluster": "Essential Eight",
    "tags": [
      "Application Hardening",
      "Browser Security",
      "Office Security",
      "Malware Protection"
    ],
    "status": "published",
    "source": "./2026-Q1/30-application-hardening-browser-office-security.mdx"
  },
  {
    "id": 29,
    "slug": "os-hardening-windows-11-security",
    "title": "OS Hardening Windows 11: Security Baseline, Essential Eight Alignment, and GPO Configuration",
    "excerpt": "Technical guide to Windows 11 security hardening aligned with Essential Eight: Windows security baseline, Group Policy hardening, attack surface reduction, Credential Guard, exploit protection, controlled folder access, and configuration management.",
    "date": "Oct 19, 2025",
    "publishDate": "2025-10-19",
    "readTime": "11 min read",
    "category": "ACSC Essential Eight",
    "pillar": "Technology",
    "semanticCluster": "Essential Eight",
    "tags": [
      "OS Hardening",
      "Windows 11",
      "Security Baseline",
      "Group Policy",
      "Malware Protection"
    ],
    "status": "published",
    "source": "./2026-Q1/29-os-hardening-windows-11-security.mdx"
  },
  {
    "id": 28,
    "slug": "essential-eight-control-5-user-privilege-management",
    "title": "Essential Eight Control 5: User Privilege Management - JIT Admin Access, LAPS, and Tiered Admin Models",
    "excerpt": "Technical implementation guide for ACSC Essential Eight Control 5 (User Privilege Management): Just-In-Time (JIT) admin access, Azure AD Privileged Identity Management, Local Admin Password Solution (LAPS), Privileged Access Workstations (PAW), tiered admin model, and break-glass accounts.",
    "date": "Oct 16, 2025",
    "publishDate": "2025-10-16",
    "readTime": "12 min read",
    "category": "ACSC Essential Eight",
    "pillar": "Technology",
    "semanticCluster": "Essential Eight",
    "tags": [
      "Privilege Management",
      "Least Privilege",
      "Admin Rights",
      "Essential Eight"
    ],
    "status": "published",
    "source": "./2026-Q1/28-essential-eight-control-5-user-privilege-management.mdx"
  },
  {
    "id": 27,
    "slug": "essential-eight-control-7-mfa-best-practices",
    "title": "Essential Eight Control 7: MFA Best Practices - From SMS to Phishing-Resistant Authentication",
    "excerpt": "Deep dive into ACSC Essential Eight Control 7 (Multi-Factor Authentication), MFA maturity levels (1-3), method comparison (SMS OTP, authenticator apps, FIDO2 hardware keys), phishing-resistant MFA Level 3 implementation, Azure AD MFA deployment, and exemption management.",
    "date": "Oct 13, 2025",
    "publishDate": "2025-10-13",
    "readTime": "11 min read",
    "category": "ACSC Essential Eight",
    "pillar": "Technology",
    "semanticCluster": "Essential Eight",
    "tags": [
      "MFA",
      "Authentication",
      "Phishing Resistance",
      "Essential Eight",
      "Azure AD"
    ],
    "status": "published",
    "source": "./2026-Q1/27-essential-eight-control-7-mfa-best-practices.mdx"
  },
  {
    "id": 26,
    "slug": "australian-security-trends-2025",
    "title": "Australian Cyber Security Trends 2025: CISO Priorities, Regulatory Evolution, and Ransomware Response",
    "excerpt": "Strategic overview of Australian cyber threat landscape in 2025, CISO priorities post-SOCI Act, Privacy Act 2025 amendments, ransomware evolution, supply chain attacks, cloud security challenges, skills shortage, and AI/ML-driven defence strategies.",
    "date": "Oct 10, 2025",
    "publishDate": "2025-10-10",
    "readTime": "12 min read",
    "category": "Technology",
    "pillar": "Multi",
    "semanticCluster": "Strategic Security",
    "tags": [
      "Security Trends",
      "CISO",
      "Australia",
      "Cyber Landscape",
      "Ransomware",
      "Regulatory",
      "Cloud Security"
    ],
    "status": "published",
    "source": "./2026-Q1/26-australian-security-trends-2025.mdx"
  },
  {
    "id": 25,
    "slug": "compliance-governance-training-course-overview",
    "title": "Compliance & Governance Training Course: Master Information Security Frameworks and Risk Management",
    "excerpt": "Comprehensive training course on compliance frameworks (ISO 27001, ACSC Essential Eight, Privacy Act, SOCI Act), governance practices, risk management, audit preparation, and certification support for compliance officers, risk managers, and IT leaders.",
    "date": "Oct 7, 2025",
    "publishDate": "2025-10-07",
    "readTime": "8 min read",
    "category": "Technology",
    "pillar": "Process",
    "semanticCluster": "Compliance Training & Education",
    "tags": [
      "Compliance",
      "Governance",
      "Training",
      "Risk Management"
    ],
    "status": "published",
    "source": "./2026-Q1/25-compliance-governance-training-course-overview.mdx"
  },
  {
    "id": 24,
    "slug": "security-assessment-roi-case-study-australian-organisation",
    "title": "Security Assessment ROI Case Study: Quantifying the Business Value of Gap Analysis and Remediation",
    "excerpt": "Real-world Australian case study demonstrating return on investment from security assessments, gap analysis, prioritised remediation roadmap, cost avoidance, insurance savings, tender competitiveness, and executive decision-making insights.",
    "date": "Oct 4, 2025",
    "publishDate": "2025-10-04",
    "readTime": "9 min read",
    "category": "Security Assessment",
    "pillar": "Process",
    "semanticCluster": "Security Assessment Value",
    "tags": [
      "Security Assessment",
      "ROI",
      "Gap Analysis",
      "Case Study"
    ],
    "status": "published",
    "source": "./2026-Q1/24-security-assessment-roi-case-study-australian-organisation.mdx"
  },
  {
    "id": 23,
    "slug": "iso-27001-vs-acsc-essential-eight-framework-mapping",
    "title": "ISO 27001 vs ACSC Essential Eight: Framework Comparison and Control Mapping",
    "excerpt": "Comprehensive framework mapping comparing ISO 27001:2022 and ACSC Essential Eight controls, understanding overlap, priorities for Australian organisations, dual compliance strategy, and which to implement first.",
    "date": "Oct 1, 2025",
    "publishDate": "2025-10-01",
    "readTime": "9 min read",
    "category": "Compliance & Governance",
    "pillar": "Process",
    "semanticCluster": "ISO 27001 Compliance",
    "tags": [
      "ISO 27001",
      "Essential Eight",
      "Framework Mapping",
      "Compliance"
    ],
    "status": "published",
    "source": "./2026-Q1/23-iso-27001-vs-acsc-essential-eight-framework-mapping.mdx"
  },
  {
    "id": 22,
    "slug": "iso-27001-annex-a-12-operations-security",
    "title": "ISO 27001 Annex A.12: Operations Security – Deep Dive into Technical Controls",
    "excerpt": "Technical deep dive into ISO 27001:2022 Annex A.12 Operations Security controls: malware protection, backup & recovery, logging & monitoring, vulnerability management, capacity planning, change management, and alignment with ACSC Essential Eight.",
    "date": "Sep 28, 2025",
    "publishDate": "2025-09-28",
    "readTime": "10 min read",
    "category": "Compliance & Governance",
    "pillar": "Technology",
    "semanticCluster": "ISO 27001 Compliance",
    "tags": [
      "ISO 27001",
      "Operations Security",
      "Technical Controls",
      "Annex A"
    ],
    "status": "published",
    "source": "./2026-Q1/22-iso-27001-annex-a-12-operations-security.mdx"
  },
  {
    "id": 21,
    "slug": "iso-27001-2022-implementation-roadmap",
    "title": "ISO 27001:2022 Implementation Roadmap: Building a Compliant Information Security Management System",
    "excerpt": "A comprehensive hub article on ISO 27001:2022 implementation for Australian organisations, covering ISMS framework, Annex A controls, gap analysis, risk assessment, and the certification pathway from planning to recertification.",
    "date": "Sep 25, 2025",
    "publishDate": "2025-09-25",
    "readTime": "12 min read",
    "category": "Compliance & Governance",
    "pillar": "Process",
    "semanticCluster": "ISO 27001 Compliance",
    "tags": [
      "ISO 27001",
      "Compliance",
      "Certification",
      "ISMS",
      "Information Security"
    ],
    "status": "published",
    "source": "./2026-Q1/21-iso-27001-2022-implementation-roadmap.mdx"
  },
  {
    "id": 20,
    "slug": "microsoft-365-security-hardening-course",
    "title": "Microsoft 365 Security Hardening: Course Overview and Hands-On Lab Experience",
    "excerpt": "Comprehensive training course for securing Microsoft 365 environments: Exchange Online, Defender for Office 365, Teams security, SharePoint hardening, DLP policies, and certification preparation.",
    "date": "Sep 22, 2025",
    "publishDate": "2025-09-22",
    "readTime": "8 min read",
    "category": "Microsoft 365",
    "pillar": "Technology",
    "semanticCluster": "Microsoft 365 Security",
    "tags": [
      "Microsoft 365",
      "Security Hardening",
      "Training",
      "Certification"
    ],
    "status": "published",
    "source": "./2025-Q2/20-microsoft-365-security-hardening-course.mdx"
  },
  {
    "id": 19,
    "slug": "security-training-roi-analysis-business-case",
    "title": "Security Training ROI Analysis: Building the Business Case for Investment",
    "excerpt": "Quantify the value of security training through cost-benefit analysis, breach cost avoidance, phishing click rate reduction ROI, and Australian breach cost data to justify ongoing security awareness investment.",
    "date": "Sep 19, 2025",
    "publishDate": "2025-09-19",
    "readTime": "8 min read",
    "category": "People",
    "pillar": "People",
    "semanticCluster": "Security Culture & Awareness",
    "tags": [
      "ROI",
      "Training Investment",
      "Business Case",
      "Breach Prevention"
    ],
    "status": "published",
    "source": "./2025-Q2/19-security-training-roi-analysis-business-case.mdx"
  },
  {
    "id": 18,
    "slug": "security-champions-programs-peer-learning",
    "title": "Building Security Champions Programs: From Selection to Impact Measurement",
    "excerpt": "Create a distributed security awareness network through volunteer champions in each department. Selection criteria, training pathways, time commitment, recognition programs, and measuring real impact on security behaviours.",
    "date": "Sep 16, 2025",
    "publishDate": "2025-09-16",
    "readTime": "9 min read",
    "category": "People",
    "pillar": "People",
    "semanticCluster": "Security Culture & Awareness",
    "tags": [
      "Security Champions",
      "Peer Learning",
      "Awareness Programs"
    ],
    "status": "published",
    "source": "./2025-Q2/18-security-champions-programs-peer-learning.mdx"
  },
  {
    "id": 17,
    "slug": "phishing-simulations-security-behavior-change",
    "title": "Phishing Simulations and Security Behaviour Design, Delivery, and Avoiding Shame Tactics",
    "excerpt": "Effective phishing simulation programs measure baseline risk, deliver targeted training pathways, track click rate improvements, and build reporting culture without shame tactics that undermine organisational trust.",
    "date": "Sep 13, 2025",
    "publishDate": "2025-09-13",
    "readTime": "9 min read",
    "category": "Security Culture",
    "pillar": "People",
    "tags": [
      "Phishing",
      "Security Awareness",
      "Social Engineering",
      "User Training"
    ],
    "status": "published",
    "source": "./2025-Q2/17-phishing-simulations-security-behavior-change.mdx"
  },
  {
    "id": 16,
    "slug": "security-culture-maturity",
    "title": "Building Security Culture Beyond Compliance",
    "excerpt": "Move beyond checkbox training and policies—build genuine security culture for Australian organisations.",
    "date": "Sep 10, 2025",
    "publishDate": "2025-09-10",
    "category": "Security Culture",
    "pillar": "Technology",
    "tags": [
      "Security Culture",
      "Security Awareness",
      "Behaviour Change",
      "Leadership",
      "ACSC"
    ],
    "status": "published",
    "source": "./2025-Q2/16-security-culture-maturity.mdx"
  },
  {
    "id": 15,
    "slug": "advanced-ad-administration-course",
    "title": "Advanced AD Administration Course: Mastering Active Directory for Enterprise Security",
    "excerpt": "Comprehensive Advanced Active Directory Administration course: AD architecture, Group Policy mastery, replication and sites, troubleshooting, security hardening, disaster recovery, hybrid cloud integration, hands-on labs, and certification pathway for IT professionals.",
    "date": "Sep 7, 2025",
    "publishDate": "2025-09-07",
    "readTime": "12 min read",
    "category": "Azure Security",
    "pillar": "People",
    "semanticCluster": "Active Directory Training",
    "tags": [
      "Active Directory",
      "Training",
      "Group Policy",
      "Disaster Recovery"
    ],
    "status": "published",
    "source": "./2025-Q1/15-advanced-ad-administration-course.mdx"
  },
  {
    "id": 14,
    "slug": "azure-ad-hybrid-identity-architecture",
    "title": "Azure AD Hybrid Identity Architecture: Synchronisation, Pass-Through Authentication, and Federation",
    "excerpt": "Deep dive into hybrid identity patterns: Azure AD Connect vs Cloud Sync, password hash sync vs pass-through authentication vs federation, SSO capabilities, migration from on-premises AD to cloud, disaster recovery, and monitoring sync health.",
    "date": "Sep 4, 2025",
    "publishDate": "2025-09-04",
    "readTime": "4 min read",
    "category": "Azure Security",
    "pillar": "Technology",
    "semanticCluster": "Azure AD Security",
    "tags": [
      "Hybrid Identity",
      "Azure AD Connect",
      "Identity Sync",
      "Cloud Migration",
      "SSO"
    ],
    "status": "published",
    "source": "./2025-Q1/14-azure-ad-hybrid-identity-architecture.mdx"
  },
  {
    "id": 13,
    "slug": "passwordless-authentication-azure-ad",
    "title": "Password-Free Authentication in Azure AD: FIDO2, Windows Hello, and Authenticator App",
    "excerpt": "Comprehensive guide to passwordless authentication implementation: Windows Hello for Business, FIDO2 security keys, Microsoft Authenticator, deployment planning, user enrolment, temporary access passes, phishing-resistant MFA for Essential Eight Level 3.",
    "date": "Sep 1, 2025",
    "publishDate": "2025-09-01",
    "readTime": "9 min read",
    "category": "Azure Security",
    "pillar": "Technology",
    "semanticCluster": "Azure AD Security",
    "tags": [
      "Passwordless",
      "FIDO2",
      "Windows Hello",
      "Azure AD",
      "Authentication",
      "Security Keys"
    ],
    "status": "published",
    "source": "./2025-Q1/13-passwordless-authentication-azure-ad.mdx"
  },
  {
    "id": 12,
    "slug": "conditional-access-policies-zero-trust",
    "title": "Conditional Access: The gatekeeper of zero trust security",
    "excerpt": "Conditional Access policies enforce zero trust by evaluating every sign-in based on identity, device health, location, and risk. This guide covers six foundational policies, advanced risk-based controls, and ACSC Essential Eight alignment for Australian organisations.",
    "date": "Aug 29, 2025",
    "publishDate": "2025-08-29",
    "readTime": "9 min read",
    "category": "Microsoft 365",
    "pillar": "Technology",
    "semanticCluster": "Microsoft 365 Security",
    "tags": [
      "Conditional Access",
      "Zero Trust",
      "Azure AD",
      "ACSC Essential Eight",
      "MFA"
    ],
    "status": "published",
    "source": "./2025-Q1/12-conditional-access-policies-zero-trust.mdx"
  },
  {
    "id": 11,
    "slug": "azure-ad-security-best-practices-2025",
    "title": "Azure AD security evolution: From basic authentication to zero trust fortress",
    "excerpt": "Azure Active Directory is the cornerstone of enterprise security. This guide covers zero trust implementation through Conditional Access, Privileged Identity Management, Identity Protection, and device compliance — with full ACSC Essential Eight and Australian regulatory alignment.",
    "date": "Aug 26, 2025",
    "publishDate": "2025-08-26",
    "readTime": "10 min read",
    "category": "Azure Security",
    "pillar": "Technology",
    "semanticCluster": "Azure AD & Identity",
    "tags": [
      "Azure AD",
      "Zero Trust",
      "ACSC Essential Eight",
      "Privileged Identity Management",
      "Identity Protection"
    ],
    "status": "published",
    "source": "./2025-Q1/11-azure-ad-security-best-practices-2025.mdx"
  },
  {
    "id": 10,
    "slug": "essential-eight-patch-management-automation",
    "title": "The patch management crisis: Why many Australian organisations fail ACSC compliance",
    "excerpt": "Manual patch management makes ACSC Essential Eight compliance impossible. This guide explains how automated patching frameworks achieve 48-hour extreme risk vulnerability deployment, satisfy Controls 2 and 6 maturity requirements, and reduce operational overhead by up to 80%.",
    "date": "Aug 23, 2025",
    "publishDate": "2025-08-23",
    "readTime": "10 min read",
    "category": "ACSC Essential Eight",
    "pillar": "Technology",
    "semanticCluster": "Essential Eight Implementation",
    "tags": [
      "Patch Management",
      "ACSC Essential Eight",
      "Automation",
      "Vulnerability Management",
      "WSUS"
    ],
    "status": "published",
    "source": "./2025-Q1/10-essential-eight-patch-management-automation.mdx"
  },
  {
    "id": 9,
    "slug": "essential-eight-fundamentals-course-overview",
    "title": "Why Essential Eight training is critical for Australian organisations",
    "excerpt": "A significant share of Australian businesses fail to reach ACSC Essential Eight Maturity Level 1, primarily due to knowledge gaps and implementation complexity. This overview explains what the Essential Eight Fundamentals course covers across all 8 controls, the ROI versus consultant dependency, and post-training implementation timelines.",
    "date": "Aug 20, 2025",
    "publishDate": "2025-08-20",
    "readTime": "14 min read",
    "category": "ACSC Essential Eight",
    "pillar": "Technology",
    "semanticCluster": "Essential Eight Implementation",
    "tags": [
      "ACSC Essential Eight",
      "Essential Eight Training",
      "Cybersecurity Training",
      "ACSC Compliance",
      "Maturity Model"
    ],
    "status": "published",
    "source": "./2025-Q1/09-essential-eight-fundamentals-course-overview.mdx"
  },
  {
    "id": 8,
    "slug": "acsc-essential-eight-assessment-guide",
    "title": "ACSC Essential Eight Assessment: What to Expect and How to Prepare",
    "excerpt": "A practical guide to Essential Eight maturity assessments for Australian organisations - including preparation checklists, evidence requirements, common gaps, and strategies to achieve Level 2+ certification.",
    "date": "Aug 17, 2025",
    "publishDate": "2025-08-17",
    "readTime": "14 min read",
    "category": "ACSC Essential Eight",
    "pillar": "Process",
    "semanticCluster": "Essential Eight Implementation",
    "tags": [
      "ACSC",
      "Essential Eight",
      "Security Assessment",
      "Compliance",
      "Cyber Audit"
    ],
    "status": "published",
    "source": "./2024-Q4/08-acsc-essential-eight-assessment-guide.mdx"
  },
  {
    "id": 7,
    "slug": "security-culture-foundations-building-human-firewall",
    "title": "Security Culture Foundations: Building the Human Firewall",
    "excerpt": "Beyond policies and training, learn how to cultivate a genuine security culture where employees become active defenders rather than the weakest link in your cyber security posture.",
    "date": "Aug 14, 2025",
    "publishDate": "2025-08-14",
    "readTime": "16 min read",
    "category": "Security Culture",
    "pillar": "People",
    "semanticCluster": "Security Culture & Awareness",
    "tags": [
      "Security Culture",
      "Security Awareness",
      "Phishing",
      "Human Risk",
      "Behaviour Change"
    ],
    "status": "published",
    "source": "./2024-Q4/07-security-culture-foundations-building-human-firewall.mdx"
  },
  {
    "id": 6,
    "slug": "application-whitelisting-technical-implementation",
    "title": "ACSC Essential Eight Control 1: Application Whitelisting Technical Implementation",
    "excerpt": "A comprehensive technical guide to implementing application control using AppLocker and WDAC for Windows environments, aligned with ACSC Essential Eight maturity levels and real-world deployment strategies for Australian organisations.",
    "date": "Aug 11, 2025",
    "publishDate": "2025-08-11",
    "readTime": "18 min read",
    "category": "ACSC Essential Eight",
    "pillar": "Technology",
    "semanticCluster": "Essential Eight Implementation",
    "tags": [
      "ACSC",
      "Essential Eight",
      "Application Control",
      "AppLocker",
      "WDAC",
      "Windows Security"
    ],
    "status": "published",
    "source": "./2024-Q4/06-application-whitelisting-technical-implementation.mdx"
  },
  {
    "id": 5,
    "slug": "acsc-essential-eight-complete-2025-guide",
    "title": "ACSC Essential Eight: Complete 2026 Implementation Guide",
    "excerpt": "A 12-month, step-by-step roadmap for Australian organisations to reach ACSC Essential Eight maturity - covering controls, configuration patterns, pitfalls, government contractor expectations, and ROI.",
    "date": "Aug 8, 2025",
    "publishDate": "2025-08-08",
    "readTime": "12 min read",
    "category": "ACSC Essential Eight",
    "pillar": "Technology",
    "semanticCluster": "Essential Eight Implementation",
    "tags": [
      "ACSC",
      "Essential Eight",
      "MFA",
      "AppLocker",
      "Backups"
    ],
    "status": "published",
    "source": "./2024-Q4/05-acsc-essential-eight-complete-2025-guide.mdx"
  },
  {
    "id": 4,
    "slug": "copilot-security-training",
    "title": "Understanding Copilot's Power and Risk",
    "excerpt": "Microsoft 365 Copilot inherits your existing Microsoft Graph permissions, making pre-existing oversharing risks immediately discoverable via natural language queries. This guide covers the governance controls, phased rollout strategy, and monitoring framework required before deploying Copilot in Australian organisations.",
    "date": "Aug 5, 2025",
    "publishDate": "2025-08-05",
    "readTime": "7 min read",
    "category": "Microsoft 365",
    "pillar": "Technology",
    "semanticCluster": "Microsoft 365 Security",
    "tags": [
      "Microsoft Copilot",
      "Microsoft 365",
      "Data Governance",
      "Privacy Act",
      "SharePoint Security"
    ],
    "status": "published",
    "source": "./2024-Q4/04-copilot-security-training.mdx"
  },
  {
    "id": 3,
    "slug": "entra-id-migration-strategy",
    "title": "Seamless Migration to Microsoft Entra ID",
    "excerpt": "A comprehensive migration roadmap from on-premises Active Directory to Microsoft Entra ID (Azure AD) with hybrid identity, security, and governance strategies for Australian organisations.",
    "date": "Aug 2, 2025",
    "publishDate": "2025-08-02",
    "readTime": "12 min read",
    "category": "Technology",
    "pillar": "Process",
    "semanticCluster": "Azure Identity Migration",
    "tags": [
      "Entra ID",
      "Azure AD",
      "Identity Migration",
      "Hybrid Identity",
      "Authentication"
    ],
    "status": "published",
    "source": "./2024-Q4/03-entra-id-migration-strategy.mdx"
  },
  {
    "id": 2,
    "slug": "hardening-active-directory",
    "title": "Hardening Active Directory: A Comprehensive Guide",
    "excerpt": "Complete technical guide to Active Directory hardening, privilege management, GPO security, and monitoring for Australian enterprises.",
    "date": "Jul 30, 2025",
    "publishDate": "2025-07-30",
    "readTime": "18 min read",
    "category": "Azure Security",
    "pillar": "Technology",
    "semanticCluster": "Active Directory Security",
    "tags": [
      "Active Directory",
      "Hardening",
      "Kerberos",
      "GPO",
      "Privileged Access"
    ],
    "status": "published",
    "source": "./2024-Q4/02-hardening-active-directory.mdx"
  },
  {
    "id": 1,
    "slug": "microsoft-security-best-practices-2025",
    "title": "Essential Microsoft Security Best Practices for 2025",
    "excerpt": "A comprehensive guide to Microsoft security configurations, Zero Trust architecture, and threat protection strategies for Australian organisations in 2025.",
    "date": "Jul 27, 2025",
    "publishDate": "2025-07-27",
    "readTime": "15 min read",
    "category": "Azure Security",
    "pillar": "Technology",
    "semanticCluster": "Microsoft 365 Security",
    "tags": [
      "Security",
      "Microsoft",
      "Zero Trust",
      "MFA",
      "Defender"
    ],
    "status": "published",
    "source": "./2024-Q4/01-microsoft-security-best-practices-2025.mdx"
  }
];
